import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActions,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme,
  useMediaQuery,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Badge,
  Divider,
  FormControlLabel,
  Checkbox,
  Alert,
  CircularProgress,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
  InputAdornment,
  TablePagination,
  List,
  ListItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StyleIcon from "@mui/icons-material/Style";
import StorefrontIcon from "@mui/icons-material/Storefront";
import BusinessIcon from "@mui/icons-material/Business";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import DiscountIcon from "@mui/icons-material/LocalOffer";
import WarningIcon from "@mui/icons-material/Warning";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import Cart from "./components/cart";
import Payment from "./components/payment";
import {
  fetchDataEngineBalance,
  generateAndExecuteMutation,
  generateAndExecuteMutationOrders,
  graphqlQuery,
} from "../../data/Axios/DynamicService";
import {
  companyManagementUrl,
  inventoryManagementUrl,
  salesManagement,
  reportsManagementUrl,
  setupManagementUrl,
} from "../../config";
import { generateReport } from "../../data/DynamicTable/DynamicFunctions";
import { tokens } from "../../theme";
import { CartItemsByUser, inventoryQuery } from "../../data/Axios/queries";
import ImprovedDetailsDialog from "./components/ViewDetails";
import { Drawer } from "@mui/material";

// GraphQL Queries
const allServiceProductsQuery = `{
  allServiceProducts {
    companyId
    costPrice
    id
    isActive
    isService
    productCategory
    productName
    retailPrice
    unitPrice
    unitofMeasure
    uomId
    wholesalePrice
  }
}`;

const warehouseInventoryViewQuery = ` {
    distributedWarehouseInventory {
        id
        productCode
        productName
        productId
        cartons
        quantityPerCarton
        buyingPricePerCarton
        sellingPricePerCarton
        totalValue
        branchName
        branchId
        regionId
        companyId
        aliasProductName
        createdByName
        updatedByName
        createdDate
        updatedDate
        isActive
        purchaseOrderItemsId
        expectedProfit
        newBuyingPricePerCarton
        newSellingPricePerCarton
        averageBP
        averageSP
        averageBpPerPair
        averageSPPerPair
        isDistributed
    }
}`;

const retailInventoryViewQueryByBranchId = (branchId) => `  {
    distributedRetailInventory ( inv: { branchId: ${branchId} } ) { 
        id
        productId
        productName
        quantity
        createdDate
        createdBy
        createdByName
        isActive
        companyId
        regionId
        branchId
        branchName
        cartons
        quantityPerCarton
        averageBuyingPrice
        averageSellingPrice
        productCode
        aliasProductName
        totalValue
        isDistributed
    }
}`;
const SearchRetailInventory = (params) => `{
  searchDistributedRetailInventory(inv: { branchId: ${params.branchId} }, searchTerm: ${JSON.stringify(params.search || "")}, limit: ${parseInt(params.limit || 10)}) {
    id
    productId
    productName
    quantity
    createdDate
    createdBy
    createdByName
    isActive
    companyId
    regionId
    branchId
    branchName
    cartons
    quantityPerCarton
    averageBuyingPrice
    averageSellingPrice
    productCode
    aliasProductName
    totalValue
    isDistributed
  }
}`;

// Server-side paginated due stock query
const DUE_STOCK_PAGE_SIZE = 20;
const DueStockQuery = (params) => `{
  dueStockItems(
    branchId: ${params.branchId},
    thresholdDays: ${params.thresholdDays || 30},
    limit: ${params.limit || DUE_STOCK_PAGE_SIZE},
    offset: ${params.offset || 0}
  ) {
    items {
      id
      purchaseOrderId
      productId
      productName
      productCode
      aliasProductName
      stockDueDate
      branchId
      quantity
      cartons
      quantityPerCarton
      isActive
      vendorName
    }
    totalCount
  }
}`;

const inventoryDetailsByProductCodeQuery = (
  productCode,
  productId,
  branchId,
) => `{
  inventoryDetailsByProductCode(inventory: { productCode: "${productCode}", branchId: ${branchId}, productId: ${productId} }) {
    id
    productCode
    productName
    productId
    colorId
    colorName
    sizeRange
    minSize
    maxSize
    quantity
    averageCost
    quantityPerCarton
    branchName
    branchId
    regionId
    companyId
    createdByName
    updatedByName
    createdDate
    updatedDate
    purchaseOrderItemsId
  }
}`;

const retailInventoryDetailsByProductCodeQuery = (
  productCode,
  productId,
  branchId,
) => `{
  retailInventoryByColumnValues(inventory:{ productCode: "${productCode}", branchId: ${branchId}, productId: ${productId} }) {
    id
    productCode
    productName
    productId
    colorId
    colorName
    size
    quantity
    branchId
    companyId
  }
}`;

const allCompanyBranchesView = `{
  allBranchView {
    id
    branchName
    isWarehouse
    createdDate
    createdBy
    updatedBy
    companyId
    company
    regionId
    region
  }
}`;

const validateProductCodeQuery = (productCode) => `{
  allRetailInventoryBySpecificColumnValues(inv: { productCode:  "${productCode}" }) {
    id
    productCode
    productName
    productId
    quantity
  }
}`;

const base_url = inventoryManagementUrl.uri;
const base_urlcompany = companyManagementUrl.uri;
const sales_url = salesManagement.uri;

const ShoeInventoryPOS = ({ onClose, onCreateOrder }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
  const saleSettings = localStorage.getItem("saleSettings") || "{}";
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const [isShiftOpen, setIsShiftOpen] = useState(false);
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);

  const canSellAtWarehouse =
    RoleGroupId === 1 || RoleGroupId === 2 || RoleGroupId === 3;

  // ✅ CRITICAL: If user can sell at warehouse, default to warehouse mode; otherwise retail only
  const [isWarehouseMode, setIsWarehouseMode] = useState(canSellAtWarehouse);

  const isDark = theme.palette.mode === "dark";

  const lightBlue = {
    main: isDark ? colors.blueAccent[500] : "#5DADE2",
    light: isDark ? colors.primary[300] : "#85C1E9",
    lighter: isDark ? colors.primary[400] : "#AED6F1",
    dark: isDark ? colors.blueAccent[600] : "#3498DB",
    header: isDark ? colors.primary[400] : "#5DADE2",
  };

  // Core states
  const [cart, setCart] = useState([]);
  const [warehouseInventory, setWarehouseInventory] = useState([]);
  const [retailInventory, setRetailInventory] = useState([]);
  const [inventoryDetails, setInventoryDetails] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  // Real-time search states
  const [searchLimit, setSearchLimit] = useState(10); // optional, defaults to 10
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  // Dialog states
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [externalSaleDialogOpen, setExternalSaleDialogOpen] = useState(false);

  // External Sale Form States
  const [externalSaleForm, setExternalSaleForm] = useState({
    product: "",
    productCode: "",
    quantity: "",
    amount: "",
    color: "",
    size: "",
  });
  const [externalSaleItems, setExternalSaleItems] = useState([]);
  const [isValidatingProductCode, setIsValidatingProductCode] = useState(false);
  const [productCodeValidation, setProductCodeValidation] = useState({
    isValid: null,
    message: "",
  });

  // Form states
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSizeRange, setSelectedSizeRange] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [isExternalBranch, setIsExternalBranch] = useState(false);

  // UI states
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoadingCart, setIsLoadingCart] = useState(false);

  // Discount Dialog States
  const [discountDialogOpen, setDiscountDialogOpen] = useState(false);
  const [selectedCartItemForDiscount, setSelectedCartItemForDiscount] =
    useState(null);
  const [discountAmount, setDiscountAmount] = useState("");
  const [applyDiscount, setApplyDiscount] = useState(false);
  const [allowBelowCostPrice, setAllowBelowCostPrice] = useState(false);

  // ✅ NEW: Price Override Dialog States
  const [priceOverrideDialogOpen, setPriceOverrideDialogOpen] = useState(false);
  const [selectedCartItemForOverride, setSelectedCartItemForOverride] =
    useState(null);
  const [overridePrice, setOverridePrice] = useState("");
  const [applyOverride, setApplyOverride] = useState(false);

  // Due Stock Dialog States
  const [dueStockDialogOpen, setDueStockDialogOpen] = useState(false);
  const [dueStockItems, setDueStockItems] = useState([]);
  const [dueStockThreshold, setDueStockThreshold] = useState(30); // days
  const [isLoadingDueStock, setIsLoadingDueStock] = useState(false);
  const [dueStockPage, setDueStockPage] = useState(0);
  const [dueStockTotalCount, setDueStockTotalCount] = useState(0);
  const [isGeneratingDueStockReport, setIsGeneratingDueStockReport] =
    useState(false);

  // Service Sale states
  const [hasService, setHasService] = useState(false);
  const [showBuyingPrice, setShowBuyingPrice] = useState(false);
  const [requireMpesaCodeForCash, setRequireMpesaCodeForCash] = useState(false);
  const [isStraightSale, setIsStraightSale] = useState(false);

  // Straight Sale (no color/size) Quick-Add states
  const [straightSaleQuickAddOpen, setStraightSaleQuickAddOpen] =
    useState(false);
  const [selectedStraightSaleProduct, setSelectedStraightSaleProduct] =
    useState(null);
  const [straightSaleQty, setStraightSaleQty] = useState("");
  const [isServiceMode, setIsServiceMode] = useState(false);
  const [serviceProducts, setServiceProducts] = useState([]);
  const [serviceQuickAddOpen, setServiceQuickAddOpen] = useState(false);
  const [selectedServiceProduct, setSelectedServiceProduct] = useState(null);
  const [serviceQty, setServiceQty] = useState("1");
  const [mobileCartOpen, setMobileCartOpen] = useState(false); 


  // Permission checks
  const canOverrideCostPrice =
    RoleGroupId === 1 ||
    RoleGroupId === 2 ||
    RoleGroupId === 3 ||
    RoleGroupId === 4;
  const canApplyPriceOverride =
    RoleGroupId === 1 ||
    RoleGroupId === 2 ||
    RoleGroupId === 3 ||
    RoleGroupId === 4;

  // Load pending cart items
  useEffect(() => {
    loadPendingCartItems();
  }, [selectedBranch]);

  const loadPendingCartItems = async () => {
    if (!selectedBranch) return;

    setIsLoadingCart(true);
    try {
      const query = `{
        cartItemsByUser(cart: { branchId: ${selectedBranch}}) {
          id
          userId
          branchId
          companyId
          isWarehouseMode
          productId
          productCode
          productName
          aliasProductName
          colorId
          colorName
          size
          sizeRange
          quantity
          isWarehouse
          uomId
          averageCost
          sellingPricePerCarton
          averageBP
          averageSP
          averageSellingPrice
          totalPrice
          isExternal
          isExternalBranch
          externalProductData
          inventoryDetailId
          quantityPerCarton
          isWholesale
          isDiscount
          discountValue
          createdDate
          updatedDate
          netAmount
          amount
        }
      }`;

      const result = await graphqlQuery(query, sales_url);

      if (result && result.length > 0) {
        const restoredCart = result.map((item) => ({
          id: item.ids,
          productCode: item.productCode,
          productName: item.productName,
          productId: item.productId,
          aliasProductName: item.aliasProductName,
          colorName: item.colorName,
          colorId: item.colorId,
          size: item.size,
          sizeRange: item.sizeRange,
          quantity: item.quantity,
          isWarehouse: item.isWarehouse,
          UOMId: item.uomId,
          averageCost: item.averageCost,
          sellingPricePerCarton: item.sellingPricePerCarton,
          averageBP: item.averageBP,
          averageSP: item.averageSP,
          averageSellingPrice: item.averageSellingPrice,
          totalPrice: item.totalPrice,
          isExternal: item.isExternal,
          isExternalBranch: item.isExternalBranch,
          externalSaleData: item.externalProductData
            ? JSON.parse(item.externalProductData)
            : null,
          inventoryDetailId: item.inventoryDetailId,
          quantityPerCarton: item.quantityPerCarton,
          isWholesale: item.isWholesale,
          isDiscount: item.isDiscount,
          discountValue: item.discountValue,
          netAmount: item.netAmount,
          originalAmount: item.amount,
          dbId: item.id,
          // ✅ NEW: Price override fields (restore from DB if available)
          isPriceOverride: item.isPriceOverride || false,
          overridePrice: item.overridePrice || null,
          overrideAmount: item.overrideAmount || 0,
          originalSellingPrice:
            item.originalSellingPrice ||
            item.averageSellingPrice ||
            item.averageSP,
          originalTotalPrice: item.originalTotalPrice || item.totalPrice,
        }));

        setCart(restoredCart);

        const externalItemsRestored = restoredCart
          .filter((item) => item.isExternal)
          .map((item) => item.externalSaleData);

        setExternalSaleItems(externalItemsRestored);
        showSnackbar(
          `Restored ${restoredCart.length} item(s) from previous session`,
        );
      }
    } catch (error) {
      console.error("Error loading pending cart items:", error);
    } finally {
      setIsLoadingCart(false);
    }
  };

  const saveCartItemToDatabase = async (cartItem) => {
    try {
      const itemInput = {
        userId: userId,
        branchId: parseInt(selectedBranch),
        companyId: companyId,
        isWarehouseMode: isWarehouseMode,
        productId: cartItem.productId || null,
        productCode: cartItem.productCode || null,
        productName: cartItem.productName || null,
        aliasProductName: cartItem.aliasProductName || null,
        colorId: cartItem.colorId || null,
        colorName: cartItem.colorName || null,
        size: cartItem.size || null,
        sizeRange: cartItem.sizeRange || null,
        quantity: cartItem.quantity,
        isWarehouse: cartItem.isWarehouse || false,
        uomId: cartItem.UOMId || null,
        averageCost: cartItem.averageCost || null,
        sellingPricePerCarton: cartItem.sellingPricePerCarton || null,
        averageBP: cartItem.averageBP || null,
        averageSP: cartItem.averageSP || null,
        averageSellingPrice: cartItem.averageSellingPrice || null,
        totalPrice: cartItem.totalPrice,
        isExternal: cartItem.isExternal || false,
        isExternalBranch: cartItem.isExternalBranch || false,
        externalProductData: cartItem.externalSaleData
          ? JSON.stringify(cartItem.externalSaleData)
          : null,
        inventoryDetailId: cartItem.inventoryDetailId || null,
        quantityPerCarton: cartItem.quantityPerCarton || null,
        isWholesale: cartItem.isWholesale || null,
        isDiscount: cartItem.isDiscount ? 1 : 0,
        discountValue: cartItem.discountValue || null,
        netAmount: cartItem.netAmount || cartItem.totalPrice,
        amount: cartItem.originalAmount || cartItem.totalPrice,
        // ✅ NEW: Price override fields
        isPriceOverride: cartItem.isPriceOverride ? 1 : 0,
        overridePrice: cartItem.overridePrice || null,
        overrideAmount: cartItem.overrideAmount || 0,
        originalSellingPrice: cartItem.originalSellingPrice || null,
        originalTotalPrice: cartItem.originalTotalPrice || null,
      };

      const res = await generateAndExecuteMutation(
        "createCartItem",
        itemInput,
        "item",
        sales_url,
      );
      return res;
    } catch (error) {
      console.error("Error saving cart item to database:", error);
    }
  };

  const updateCartItemInDatabase = async (cartItem) => {
    try {
      if (!cartItem.id) return;

      const itemInput = {
        id: parseInt(cartItem.id),
        branchId: parseInt(selectedBranch),
        isDiscount: cartItem.isDiscount ? 1 : 0,
        discountValue: cartItem.discountValue || null,
        netAmount: cartItem.netAmount || cartItem.totalPrice,
        amount: cartItem.originalAmount || cartItem.totalPrice,
        totalPrice: cartItem.totalPrice,
        // ✅ NEW: Price override fields
        isPriceOverride: cartItem.isPriceOverride ? 1 : 0,
        overridePrice: cartItem.overridePrice || null,
        overrideAmount: cartItem.overrideAmount || 0,
      };

      await generateAndExecuteMutation(
        "updateCartItem",
        itemInput,
        "item",
        sales_url,
      );
    } catch (error) {
      console.error("Error updating cart item in database:", error);
    }
  };

  // Fetch functions
  const fetchBranches = async () => {
    try {
      const result = await graphqlQuery(
        allCompanyBranchesView,
        base_urlcompany,
      );
      const excludedWords = [
        "external",
        "outsource",
        "outsourced",
        "externalized",
        "outsourcing",
      ];

      if (isWarehouseMode) {
        const warehouseBranches = result.filter(
          (branch) =>
            branch.isWarehouse === 1 &&
            !excludedWords.some((word) =>
              branch.branchName.toLowerCase().includes(word),
            ),
        );
        setBranches(warehouseBranches);
        if (warehouseBranches.length > 0 && !selectedBranch) {
          setSelectedBranch(warehouseBranches[0].id);
        }
      } else {
        const retailBranches = result.filter(
          (branch) =>
            branch.isWarehouse === 0 &&
            !excludedWords.some((word) =>
              branch.branchName.toLowerCase().includes(word),
            ),
        );
        setBranches(retailBranches);
        if (retailBranches.length > 0 && !selectedBranch) {
          setSelectedBranch(retailBranches[0].id);
        }
      }
    } catch (error) {
      console.error("Failed to load branches:", error);
      showSnackbar("Failed to load branches");
    }
  };

  const fetchWarehouseInventory = async () => {
    try {
      const result = await graphqlQuery(warehouseInventoryViewQuery, base_url);
      const filteredInventory = result.filter(
        (item) =>
          item.isActive === true &&
          parseInt(item.branchId) === parseInt(selectedBranch),
      );
      setWarehouseInventory(filteredInventory);
    } catch (error) {
      console.error("Failed to load warehouse inventory:", error);
      showSnackbar("Failed to load warehouse inventory");
    }
  };

  const fetchRetailInventory = async () => {
    try {
      const query = await retailInventoryViewQueryByBranchId(selectedBranch);
      const result = await graphqlQuery(query, base_url);
      const filteredInventory = result.filter(
        (item) =>
          item.isActive === true &&
          parseInt(item.branchId) === parseInt(selectedBranch),
      );

      // Map each item to the expected structure without grouping
      // Each product code is displayed separately since they are what gets sold
      const inventoryWithProperStructure = filteredInventory.map((item) => ({
        id: item.id,
        productCode: item.productCode,
        productName: item.productName,
        productId: item.productId,
        totalQuantity: item.quantity, // Use the item's quantity directly, no summing
        sellingPrice: item.sellingPrice,
        averageSellingPrice: item.averageSellingPrice,
        averageBuyingPrice: item.averageBuyingPrice,
        branchId: item.branchId,
        branchName: item.branchName,
        aliasProductName: item.aliasProductName,
      }));

      setRetailInventory(inventoryWithProperStructure);
    } catch (error) {
      console.error("Failed to load retail inventory:", error);
      showSnackbar("Failed to load retail inventory");
    }
  };

  // Real-time search: debounce user input and call server for retail inventory
  useEffect(() => {
    if (isWarehouseMode || isServiceMode) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }
    if (!selectedBranch) {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }
    const q = (searchQuery || "").trim();
    if (q === "") {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }
    setIsSearching(true);
    const handler = setTimeout(async () => {
      try {
        const query = SearchRetailInventory({
          branchId: selectedBranch,
          search: q,
          limit: searchLimit,
        });
        const result = await graphqlQuery(query, base_url);
        const inventoryWithProperStructure = (result || []).map((item) => ({
          id: item.id,
          productCode: item.productCode,
          productName: item.productName,
          productId: item.productId,
          totalQuantity: item.quantity,
          sellingPrice: item.sellingPrice,
          averageSellingPrice: item.averageSellingPrice,
          averageBuyingPrice: item.averageBuyingPrice,
          branchId: item.branchId,
          branchName: item.branchName,
          aliasProductName: item.aliasProductName,
        }));
        setSearchResults(inventoryWithProperStructure);
      } catch (error) {
        console.error("Failed to search retail inventory:", error);
      } finally {
        setIsSearching(false);
      }
    }, 350);
    return () => clearTimeout(handler);
  }, [
    searchQuery,
    searchLimit,
    selectedBranch,
    isWarehouseMode,
    isServiceMode,
  ]);

  const fetchWarehouseInventoryDetails = async (
    productCode,
    productId,
    BranchId,
  ) => {
    try {
      const query = inventoryDetailsByProductCodeQuery(
        productCode,
        productId,
        `${BranchId}`,
      );
      const result = await graphqlQuery(query, base_url);
      setInventoryDetails(result);
    } catch (error) {
      console.error("Failed to load inventory details:", error);
      showSnackbar("Failed to load inventory details");
    }
  };

  const fetchRetailInventoryDetails = async (
    productCode,
    productId,
    BranchId,
  ) => {
    try {
      const query = retailInventoryDetailsByProductCodeQuery(
        productCode,
        productId,
        BranchId,
      );
      const result = await graphqlQuery(query, base_url);
      setInventoryDetails(result);
    } catch (error) {
      console.error("Failed to load inventory details:", error);
      showSnackbar("Failed to load inventory details");
    }
  };

  const validateProductCode = async (productCode) => {
    if (!productCode || productCode.trim() === "") {
      setProductCodeValidation({ isValid: null, message: "" });
      return;
    }

    setIsValidatingProductCode(true);
    setProductCodeValidation({ isValid: null, message: "Validating..." });

    try {
      const query = validateProductCodeQuery(productCode.trim());
      const result = await graphqlQuery(query, base_url);

      if (result && result.length > 0) {
        const totalQuantity = result.reduce(
          (sum, item) => sum + (item.quantity || 0),
          0,
        );
        const productName = result[0].productName;
        const branchesWithStock = result.filter((item) => item.quantity > 0);

        if (totalQuantity > 0) {
          setProductCodeValidation({
            isValid: false,
            message: `⚠️ Cannot create external sale: "${productName}" has ${totalQuantity} units in stock across ${branchesWithStock.length} branch(es). Please sell from inventory.`,
            hasStock: true,
            totalQuantity,
            productName,
          });
        } else {
          setProductCodeValidation({
            isValid: true,
            message: `✓ Product found: "${productName}" (Currently out of stock - external sale allowed)`,
            hasStock: false,
            totalQuantity: 0,
            productName,
          });
        }
      } else {
        setProductCodeValidation({
          isValid: true,
          message: "✓ Product code not in system - external sale allowed",
          hasStock: false,
        });
      }
    } catch (error) {
      console.error("Error validating product code:", error);
      setProductCodeValidation({
        isValid: false,
        message: "Error validating product code. Please try again.",
      });
    } finally {
      setIsValidatingProductCode(false);
    }
  };
  //deployment test
  // Fetch Due Stock — server-side paginated
  const fetchDueStock = async (page = 0) => {
    if (!selectedBranch) {
      showSnackbar("Please select a branch first");
      return;
    }

    setIsLoadingDueStock(true);
    try {
      const query = DueStockQuery({
        branchId: selectedBranch,
        thresholdDays: dueStockThreshold,
        limit: DUE_STOCK_PAGE_SIZE,
        offset: page * DUE_STOCK_PAGE_SIZE,
      });
      const response = await graphqlQuery(query, sales_url);

      const items = response?.items || [];
      const totalCount = response?.totalCount || 0;

      // Calculate daysUntilDue client-side (simple math, no extra query needed)
      const today = new Date();
      // Reset time to start of day for accurate day calculation
      today.setHours(0, 0, 0, 0);

      const enriched = items.map((item) => {
        const itemDueDate = new Date(item.stockDueDate);
        itemDueDate.setHours(0, 0, 0, 0);
        return {
          ...item,
          daysUntilDue: Math.ceil(
            (itemDueDate - today) / (1000 * 60 * 60 * 24),
          ),
        };
      });

      setDueStockItems(enriched);
      setDueStockTotalCount(totalCount);
      setDueStockPage(page);
      setDueStockDialogOpen(true);
    } catch (error) {
      console.error("Failed to load due stock:", error);
      showSnackbar("Failed to load due stock items");
    } finally {
      setIsLoadingDueStock(false);
    }
  };

  // Due Stock Dialog Handlers
  const handleOpenDueStockDialog = () => {
    fetchDueStock();
  };

  const handleCloseDueStockDialog = () => {
    setDueStockDialogOpen(false);
    setDueStockItems([]);
    setDueStockPage(0);
    setDueStockTotalCount(0);
  };

  const handleGenerateDueStockReport = async () => {
    try {
      // Date range: today → today + threshold
      // Captures only upcoming items approaching their due date
      const today = new Date();
      const futureDate = new Date();
      futureDate.setDate(today.getDate() + dueStockThreshold);

      const fmt = (d) => d.toISOString().split("T")[0];

      const mutationData = {
        ReportTypeId: 1022,
        ReportType: "Stock Approaching Due Report",
        BranchId: selectedBranch ? parseInt(selectedBranch) : null,
        StartDate: null,
        EndDate: fmt(futureDate),
      };

      const newTab = window.open("", "_blank");
      newTab.document.write(
        `<html><head><title>Loading...</title></head><body>
          <div style="font-family:Arial;display:flex;justify-content:center;align-items:center;height:100vh;font-size:24px;color:#333">
            Loading, please wait...
          </div>
        </body></html>`,
      );
      newTab.document.close();

      const response = await generateReport(
        mutationData,
        reportsManagementUrl.generate_report_uri,
        setIsGeneratingDueStockReport,
      );

      if (response.ok) {
        const html = await response.text();
        newTab.document.open();
        newTab.document.write(html);
        newTab.document.close();
      } else {
        newTab.close();
        Swal.fire({
          icon: "error",
          title: "Report Error",
          text: "Could not generate the Stock Due Report. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error generating due stock report:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error occurred while generating the report.",
      });
    }
  };

  const handleViewDueStockItem = async (item) => {
    try {
      // Due stock items come from Purchase Orders, whose productCode often differs
      // from the distributed inventory productCode (e.g. PO code "2324" vs distributed
      // code "40770y" for the same productId). So we match by productId, not productCode.
      let priceSource = null;

      if (isWarehouseMode) {
        // Try exact match first (productId + productCode), then productId-only
        priceSource =
          warehouseInventory.find(
            (i) =>
              i.productId === item.productId &&
              i.productCode === item.productCode,
          ) || warehouseInventory.find((i) => i.productId === item.productId);
      } else {
        // Try exact match first (productId + productCode), then productId-only
        priceSource =
          retailInventory.find(
            (i) =>
              i.productId === item.productId &&
              i.productCode === item.productCode,
          ) || retailInventory.find((i) => i.productId === item.productId);
      }

      // If still not found in loaded inventory, fetch from server by product name
      if (!priceSource) {
        const query = SearchRetailInventory({
          branchId: selectedBranch,
          search: item.productName,
          limit: 50,
        });
        const result = await graphqlQuery(query, base_url);
        priceSource = (result || []).find(
          (i) => i.productId === item.productId,
        );
      }

      const itemWithPrices = {
        ...item,
        totalQuantity: priceSource?.totalQuantity || priceSource?.quantity || 0,
        averageSellingPrice: priceSource?.averageSellingPrice || 0,
        averageBuyingPrice: priceSource?.averageBuyingPrice || 0,
        sellingPrice:
          priceSource?.averageSellingPrice || priceSource?.sellingPrice || 0,
        branchId: item.branchId,
      };

      // Reuse existing view product dialog (same flow as normal POS)
      handleOpenDetailsDialog(itemWithPrices);
      handleCloseDueStockDialog();
    } catch (error) {
      console.error("Failed to fetch prices for due stock item:", error);
      showSnackbar("Failed to load item prices. Please try again.");
    }
  };

  useEffect(() => {
    fetchBranches();
  }, [isWarehouseMode]);

  useEffect(() => {
    if (selectedBranch) {
      if (isWarehouseMode) {
        fetchWarehouseInventory();
      } else {
        fetchRetailInventory();
      }
    }
  }, [selectedBranch, branches, isWarehouseMode]);
  useEffect(() => {
    if (selectedBranch) {
      localStorage.setItem("pos_selected_branch_id", selectedBranch);
    }
  }, [selectedBranch]);

  const handleBranchChange = (event) => {
    const newBranchId = event.target.value;
    setSelectedBranch(newBranchId);

    // Save to localStorage
    localStorage.setItem("pos_selected_branch_id", newBranchId);

    setCart([]);
  };

  const handleOpenDetailsDialog = async (product) => {
    if (!isShiftOpen) {
      showSnackbar("Please open a shift before viewing details.");
      return;
    }

    setSelectedProduct(product);
    if (isWarehouseMode) {
      fetchWarehouseInventoryDetails(
        product.productCode,
        product.productId,
        `${selectedBranch}`,
      );
    } else {
      fetchRetailInventoryDetails(
        product.productCode,
        product.productId,
        selectedBranch,
      );
    }
    setOpenDetailsDialog(true);
  };

  const resetDetailsDialog = () => {
    setSelectedProduct(null);
    setInventoryDetails([]);
    setSelectedColor("");
    setSelectedSizeRange("");
    setSelectedSize("");
    setQuantity("");
    setIsExternalBranch(false);
    setOpenDetailsDialog(false);
  };

  const handleAddToCart = async (product, itemDetails) => {
    let newCartItem;

    if (isWarehouseMode) {
      const totalPrice = itemDetails.quantity * product.averageSP;
      newCartItem = {
        id: `${product.productCode}-${itemDetails.colorName}-${
          itemDetails.sizeRange
        }-${Date.now()}`,
        productCode: product.productCode,
        productName: product.productName,
        productId: product.productId,
        aliasProductName: product.aliasProductName,
        isWarehouse: true,
        quantity: itemDetails.quantity,
        quantityPerCarton: itemDetails.quantityPerCarton || 0,
        averageCost: itemDetails.averageCost,
        sellingPricePerCarton: product.sellingPricePerCarton,
        totalPrice: totalPrice,
        originalAmount: totalPrice,
        netAmount: totalPrice,
        averageBP: product.averageBP,
        averageSP: product.averageSP,
        inventoryDetailId: itemDetails.id,
        UOMId: 2,
        isExternal: false,
        isDiscount: false,
        discountValue: 0,
        // ✅ NEW: Price override fields
        originalSellingPrice: product.averageSP,
        originalAverageBP: product.averageBP,
        isPriceOverride: false,
        overridePrice: null,
        overrideAmount: 0,
        isBaclkDated: itemDetails.isBackDated,
        createdDate: itemDetails.createdDate,
        originalTotalPrice: totalPrice,
      };
    } else {
      const totalPrice = itemDetails.quantity * product.averageSellingPrice;
      newCartItem = {
        id: `${product.productCode}-${itemDetails.selectedColor}-${
          itemDetails.selectedSize
        }-${Date.now()}`,
        productCode: product.productCode,
        productName: product.productName,
        productId: product.productId,
        aliasProductName: product.aliasProductName,
        colorName: itemDetails.selectedColor,
        colorId: itemDetails.colorId,
        size: itemDetails.selectedSize,
        quantity: itemDetails.quantity,
        averageSellingPrice: product.averageSellingPrice,
        averageBuyingPrice: product.averageBuyingPrice,
        sellingPrice: product.sellingPrice || product.newSellingPrice,
        totalPrice: totalPrice,
        originalAmount: totalPrice,
        netAmount: totalPrice,
        inventoryDetailId: itemDetails.id,
        UOMId: 1,
        isExternal: false,
        isDiscount: false,
        discountValue: 0,
        // ✅ NEW: Price override fields
        originalSellingPrice: product.averageSellingPrice,
        isPriceOverride: false,
        overridePrice: null,
        overrideAmount: 0,
        createdDate: itemDetails.createdDate,
        isBaclkDated: itemDetails.isBackDated,
        originalTotalPrice: totalPrice,
      };
    }

    setCart((prevCart) => [...prevCart, newCartItem]);

    const dbId = await saveCartItemToDatabase(newCartItem);
    if (dbId?.createCartItem?.id) {
      newCartItem.id = dbId.createCartItem.id;
    }

    showSnackbar(
      isWarehouseMode
        ? `Added ${itemDetails.quantity} carton(s) of ${newCartItem.productName}`
        : `Added ${itemDetails.quantity} pair(s) of ${itemDetails.selectedColor} Size ${itemDetails.selectedSize}`,
    );
  };

  // Straight Sale Handlers (no color/size selection — entryOrder 4)
  const handleOpenStraightSaleQuickAdd = (product) => {
    if (!isShiftOpen) {
      showSnackbar("Please open a shift before adding items.");
      return;
    }
    setSelectedStraightSaleProduct(product);
    setStraightSaleQty("");
    setStraightSaleQuickAddOpen(true);
  };

  const handleAddStraightSaleToCart = async () => {
    const qty = parseFloat(straightSaleQty);
    if (!selectedStraightSaleProduct || isNaN(qty) || qty <= 0) return;
    const product = selectedStraightSaleProduct;

    let newCartItem;
    if (isWarehouseMode) {
      const unitPrice = product.averageSP ?? product.sellingPricePerCarton ?? 0;
      const totalPrice = qty * unitPrice;
      newCartItem = {
        id: `${product.productCode}-straight-${Date.now()}`,
        productCode: product.productCode,
        productName: product.productName,
        productId: product.productId,
        aliasProductName: product.aliasProductName,
        isWarehouse: true,
        quantity: qty,
        quantityPerCarton: product.quantityPerCarton || 0,
        averageCost: product.averageBP,
        sellingPricePerCarton: product.sellingPricePerCarton,
        totalPrice,
        originalAmount: totalPrice,
        netAmount: totalPrice,
        averageBP: product.averageBP,
        averageSP: product.averageSP,
        inventoryDetailId: null,
        UOMId: 2,
        isExternal: false,
        isDiscount: false,
        discountValue: 0,
        originalSellingPrice: product.averageSP,
        originalAverageBP: product.averageBP,
        isPriceOverride: false,
        overridePrice: null,
        overrideAmount: 0,
        originalTotalPrice: totalPrice,
      };
    } else {
      const unitPrice = product.averageSellingPrice ?? 0;
      const totalPrice = qty * unitPrice;
      newCartItem = {
        id: `${product.productCode}-straight-${Date.now()}`,
        productCode: product.productCode,
        productName: product.productName,
        productId: product.productId,
        aliasProductName: product.aliasProductName,
        colorName: null,
        colorId: null,
        size: null,
        quantity: qty,
        averageSellingPrice: unitPrice,
        averageBuyingPrice: product.averageBuyingPrice,
        sellingPrice: product.sellingPrice,
        totalPrice,
        originalAmount: totalPrice,
        netAmount: totalPrice,
        inventoryDetailId: null,
        UOMId: 1,
        isExternal: false,
        isDiscount: false,
        discountValue: 0,
        originalSellingPrice: unitPrice,
        isPriceOverride: false,
        overridePrice: null,
        overrideAmount: 0,
        originalTotalPrice: totalPrice,
      };
    }

    setCart((prev) => [...prev, newCartItem]);
    const dbId = await saveCartItemToDatabase(newCartItem);
    if (dbId?.createCartItem?.id) {
      newCartItem.id = dbId.createCartItem.id;
    }

    setStraightSaleQuickAddOpen(false);
    showSnackbar(`Added ${qty} x ${product.productName} to cart`);
  };

  const handleOpenPaymentDialog = () => {
    if (cart.length > 0) {
      setPaymentDialogOpen(true);
    } else {
      showSnackbar("Cart is empty! Add items to checkout.");
    }
  };

  // External Sale Handlers
  const handleOpenExternalSaleDialog = () => {
    if (!isShiftOpen) {
      showSnackbar("Please open a shift before recording external sales.");
      return;
    }
    setExternalSaleDialogOpen(true);
  };

  const handleCloseExternalSaleDialog = () => {
    setExternalSaleDialogOpen(false);
    setExternalSaleForm({
      product: "",
      productCode: "",
      quantity: "",
      amount: "",
      color: "",
      size: "",
    });
    setExternalSaleItems([]);
    setProductCodeValidation({ isValid: null, message: "" });
  };

  const handleExternalSaleFormChange = (field, value) => {
    setExternalSaleForm((prev) => ({ ...prev, [field]: value }));
    if (field === "productCode") {
      validateProductCode(value);
    }
  };

  const handleAddExternalSaleItem = async () => {
    if (
      !externalSaleForm.product ||
      !externalSaleForm.amount ||
      !externalSaleForm.quantity
    ) {
      showSnackbar("Please fill in product name, quantity, and amount");
      return;
    }

    if (parseFloat(externalSaleForm.quantity) <= 0) {
      showSnackbar("Quantity must be greater than 0");
      return;
    }

    if (productCodeValidation.hasStock === true) {
      Swal.fire({
        icon: "error",
        title: "Cannot Create External Sale",
        html: `
          <p><strong>${productCodeValidation.productName}</strong> has <strong>${productCodeValidation.totalQuantity} units</strong> available in inventory.</p>
          <p>Please sell from the existing inventory instead of creating an external sale.</p>
        `,
        confirmButtonText: "OK",
        confirmButtonColor: "#E74C3C",
      });
      return;
    }

    const newExternalItem = {
      id: `external-${Date.now()}`,
      product: externalSaleForm.product,
      productCode: externalSaleForm.productCode || "N/A",
      quantity: parseFloat(externalSaleForm.quantity),
      amount: parseFloat(externalSaleForm.amount),
      color: externalSaleForm.color || "N/A",
      size: externalSaleForm.size || "N/A",
      isExternal: true,
      productCodeExists:
        productCodeValidation.isValid === true &&
        !productCodeValidation.hasStock,
    };

    setExternalSaleItems((prev) => [...prev, newExternalItem]);

    const totalPrice = newExternalItem.amount * newExternalItem.quantity;
    const cartItem = {
      id: newExternalItem.id,
      productCode: newExternalItem.productCode,
      productName: newExternalItem.product,
      colorName: newExternalItem.color,
      size: parseInt(newExternalItem.size) || 0,
      quantity: newExternalItem.quantity,
      totalPrice: totalPrice,
      originalAmount: totalPrice,
      netAmount: totalPrice,
      averageSellingPrice: newExternalItem.amount,
      isExternal: true,
      isExternalBranch: true,
      UOMId: 1,
      externalSaleData: newExternalItem,
      isDiscount: false,
      discountValue: 0,
      // ✅ NEW: Price override fields
      isPriceOverride: false,
      overridePrice: null,
      overrideAmount: 0,
      originalTotalPrice: totalPrice,
      originalSellingPrice: newExternalItem.amount,
    };

    setCart((prevCart) => [...prevCart, cartItem]);

    const dbId = await saveCartItemToDatabase(cartItem);
    if (dbId?.createCartItem?.id) {
      cartItem.dbId = dbId.createCartItem.id;
    }

    setExternalSaleForm({
      product: "",
      productCode: "",
      quantity: "",
      amount: "",
      color: "",
      size: "",
    });
    setProductCodeValidation({ isValid: null, message: "" });

    showSnackbar("External sale item added to cart");
  };

  const handleRemoveExternalSaleItem = (itemId) => {
    setExternalSaleItems((prev) => prev.filter((item) => item.id !== itemId));
    setCart((prevCart) => prevCart.filter((item) => item.id !== itemId));
  };

  const handleFinalizeExternalSale = () => {
    if (externalSaleItems.length === 0) {
      showSnackbar("No external sale items added");
      return;
    }
    showSnackbar(
      `${externalSaleItems.length} external sale item(s) added to cart`,
    );
    handleCloseExternalSaleDialog();
  };

  // Service Sale Handlers
  const handleOpenServiceQuickAdd = (product) => {
    if (!isShiftOpen) {
      showSnackbar("Please open a shift before selling services.");
      return;
    }
    setSelectedServiceProduct(product);
    setServiceQty("1");
    setServiceQuickAddOpen(true);
  };

  const handleAddServiceToCart = async () => {
    const qty = parseFloat(serviceQty);
    if (!selectedServiceProduct || isNaN(qty) || qty <= 0) return;

    const unitPrice =
      selectedServiceProduct.unitPrice ||
      selectedServiceProduct.retailPrice ||
      0;
    const totalPrice = qty * unitPrice;

    const cartItem = {
      id: `service-${selectedServiceProduct.id}-${Date.now()}`,
      productId: selectedServiceProduct.id,
      productName: selectedServiceProduct.productName,
      productCode: null,
      quantity: qty,
      unitPrice: unitPrice,
      totalPrice: totalPrice,
      originalAmount: totalPrice,
      netAmount: totalPrice,
      isService: true,
      isWarehouse: false,
      isExternal: false,
      UOMId: selectedServiceProduct.uomId || 1,
      isDiscount: false,
      discountValue: 0,
      isPriceOverride: false,
      overridePrice: null,
      overrideAmount: 0,
      originalSellingPrice: unitPrice,
      originalTotalPrice: totalPrice,
      averageSellingPrice: unitPrice,
    };

    setCart((prev) => [...prev, cartItem]);
    const dbId = await saveCartItemToDatabase(cartItem);
    if (dbId?.createCartItem?.id) {
      cartItem.id = dbId.createCartItem.id;
    }

    setServiceQuickAddOpen(false);
    showSnackbar(
      `Added ${qty} x ${selectedServiceProduct.productName} to cart`,
    );
  };

  // Discount Dialog Handlers
  const handleOpenDiscountDialog = (cartIndex) => {
    const item = cart[cartIndex];
    setSelectedCartItemForDiscount({ item, index: cartIndex });
    setDiscountAmount(item.discountValue || "");
    setApplyDiscount(item.isDiscount || false);
    setDiscountDialogOpen(true);
  };

  const handleCloseDiscountDialog = () => {
    setDiscountDialogOpen(false);
    setSelectedCartItemForDiscount(null);
    setDiscountAmount("");
    setApplyDiscount(false);
    setAllowBelowCostPrice(false);
  };

  // ✅ NEW: Price Override Dialog Handlers
  const handleOpenPriceOverrideDialog = (cartIndex) => {
    const item = cart[cartIndex];
    setSelectedCartItemForOverride({ item, index: cartIndex });

    const currentPricePerUnit = item.isPriceOverride
      ? item.overridePrice
      : item.isWarehouse
        ? item.averageSP
        : item.averageSellingPrice;

    setOverridePrice(currentPricePerUnit || "");
    setApplyOverride(item.isPriceOverride || false);
    setPriceOverrideDialogOpen(true);
  };

  const handleClosePriceOverrideDialog = () => {
    setPriceOverrideDialogOpen(false);
    setSelectedCartItemForOverride(null);
    setOverridePrice("");
    setApplyOverride(false);
  };

  // ✅ NEW: Apply Price Override
  const handleApplyPriceOverride = async () => {
    if (!selectedCartItemForOverride) return;

    const { item, index } = selectedCartItemForOverride;
    const originalPricePerUnit =
      item.originalSellingPrice ||
      (item.isWarehouse ? item.averageSP : item.averageSellingPrice);

    if (!applyOverride) {
      const originalTotal = originalPricePerUnit * item.quantity;
      const updatedCart = [...cart];
      updatedCart[index] = {
        ...item,
        isPriceOverride: false,
        overridePrice: null,
        overrideAmount: 0,
        totalPrice: originalTotal,
        originalTotalPrice: originalTotal,
        netAmount: item.isDiscount
          ? originalTotal - (item.discountValue || 0)
          : originalTotal,
        originalAmount: originalTotal,
        ...(item.isWarehouse
          ? { averageSP: originalPricePerUnit }
          : { averageSellingPrice: originalPricePerUnit }),
      };
      setCart(updatedCart);
      await updateCartItemInDatabase(updatedCart[index]);
      showSnackbar("Price override removed - reset to original price");
      handleClosePriceOverrideDialog();
      return;
    }

    const newPrice = parseFloat(overridePrice);
    if (isNaN(newPrice) || newPrice <= 0) {
      showSnackbar("Please enter a valid price");
      return;
    }

    if (newPrice < originalPricePerUnit) {
      await Swal.fire({
        icon: "error",
        title: "Invalid Price Override",
        html: `
          <div style="text-align: left;">
            <p><strong>Price override must be higher than the original selling price.</strong></p>
            <hr/>
            <p><strong>Original Selling Price:</strong> KSh ${originalPricePerUnit.toFixed(
              2,
            )}</p>
            <p><strong>Your Override Price:</strong> KSh ${newPrice.toFixed(
              2,
            )}</p>
            <hr/>
            <p style="background: #FFEBEE; padding: 10px; border-left: 4px solid #E74C3C; margin-top: 10px;">
              <strong>⚠️ Error:</strong> The override price is KSh ${(
                originalPricePerUnit - newPrice
              ).toFixed(2)} below the original price.
            </p>
            <p style="margin-top: 10px;">
              Price overrides are meant to <strong>increase</strong> the selling price above the default. 
              To reduce the price, use the <strong>Discount</strong> feature instead.
            </p>
            <hr/>
            <p><strong>Minimum Override Price Allowed:</strong> KSh ${originalPricePerUnit.toFixed(
              2,
            )}</p>
          </div>
        `,
        confirmButtonText: "OK, I Understand",
        confirmButtonColor: "#E74C3C",
      });
      return;
    }

    // ✅ Prevent override with no increase (same as original)
    if (newPrice === originalPricePerUnit) {
      await Swal.fire({
        icon: "warning",
        title: "No Change Detected",
        html: `
          <p>The override price (KSh ${newPrice.toFixed(
            2,
          )}) is the same as the original price.</p>
          <p>Please enter a price <strong>higher than</strong> KSh ${originalPricePerUnit.toFixed(
            2,
          )} to apply an override.</p>
        `,
        confirmButtonText: "OK",
        confirmButtonColor: "#FFA726",
      });
      return;
    }

    const newTotalPrice = newPrice * item.quantity;
    const overrideAmount = (newPrice - originalPricePerUnit) * item.quantity;
    const originalTotal = originalPricePerUnit * item.quantity;

    const updatedCart = [...cart];
    updatedCart[index] = {
      ...item,
      isPriceOverride: true,
      overridePrice: newPrice,
      overrideAmount: overrideAmount,
      totalPrice: newTotalPrice,
      originalTotalPrice: originalTotal,
      netAmount: item.isDiscount
        ? newTotalPrice - (item.discountValue || 0)
        : newTotalPrice,
      originalAmount: newTotalPrice,
      ...(item.isWarehouse
        ? { averageSP: newPrice }
        : { averageSellingPrice: newPrice }),
    };

    setCart(updatedCart);
    await updateCartItemInDatabase(updatedCart[index]);
    showSnackbar(
      `Price override applied: KSh ${originalPricePerUnit.toFixed(
        2,
      )} → KSh ${newPrice.toFixed(2)} (+KSh ${overrideAmount.toFixed(2)} total)`,
    );
    handleClosePriceOverrideDialog();
  };

  const calculateBuyingPrice = (item) => {
    if (item.isWarehouse) {
      return item.averageBP || item.averageCost || 0;
    } else {
      return item.averageBuyingPrice || item.averageCost || 0;
    }
  };

  // Apply Discount Handler
  const handleApplyDiscount = async () => {
    if (!selectedCartItemForDiscount) return;

    const { item, index } = selectedCartItemForDiscount;

    if (!applyDiscount) {
      const updatedCart = [...cart];
      updatedCart[index] = {
        ...item,
        isDiscount: false,
        discountValue: 0,
        netAmount: item.originalAmount || item.totalPrice,
      };
      setCart(updatedCart);
      await updateCartItemInDatabase(updatedCart[index]);
      showSnackbar("Discount removed");
      handleCloseDiscountDialog();
      return;
    }

    const discount = parseFloat(discountAmount);
    if (isNaN(discount) || discount < 0) {
      showSnackbar("Please enter a valid discount amount");
      return;
    }

    if (discount > item.totalPrice) {
      showSnackbar("Discount cannot exceed the total price");
      return;
    }

    const netAmount = item.totalPrice - discount;
    const buyingPricePerUnit = calculateBuyingPrice(item);
    const totalBuyingPrice = buyingPricePerUnit * item.quantity;

    if (netAmount < totalBuyingPrice) {
      if (canOverrideCostPrice && allowBelowCostPrice) {
        const result = await Swal.fire({
          icon: "warning",
          title: "Override Cost Price Protection",
          html: `
            <div style="text-align: left;">
              <p><strong>⚠️ You are about to sell below cost price!</strong></p>
              <hr/>
              <p><strong>Original Amount:</strong> KSh ${item.totalPrice.toFixed(
                2,
              )}</p>
              <p><strong>Discount:</strong> KSh ${discount.toFixed(2)}</p>
              <p><strong>Net Amount:</strong> KSh ${netAmount.toFixed(2)}</p>
              <hr/>
              <p><strong>Cost Price:</strong> KSh ${totalBuyingPrice.toFixed(
                2,
              )}</p>
              <p style="color: #E74C3C; font-size: 18px;"><strong>Loss:</strong> KSh ${(
                totalBuyingPrice - netAmount
              ).toFixed(2)}</p>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Yes, Apply Discount",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#E74C3C",
        });

        if (!result.isConfirmed) return;
      } else {
        await Swal.fire({
          icon: "error",
          title: "Invalid Discount",
          html: `<p>The discount results in a loss. Maximum discount: KSh ${(
            item.totalPrice - totalBuyingPrice
          ).toFixed(2)}</p>`,
          confirmButtonColor: "#E74C3C",
        });
        return;
      }
    }

    const updatedCart = [...cart];
    updatedCart[index] = {
      ...item,
      isDiscount: true,
      discountValue: discount,
      netAmount: netAmount,
      originalAmount: item.originalAmount || item.totalPrice,
    };

    setCart(updatedCart);
    await updateCartItemInDatabase(updatedCart[index]);
    showSnackbar(`Discount of KSh ${discount.toFixed(2)} applied successfully`);
    handleCloseDiscountDialog();
  };

  const handleConfirmPayment = async () => {
    try {
      const mutation = `mutation ClearCart { clearCart }`;
      await graphqlQuery(mutation, sales_url);

      // setCart([]);
      // setExternalSaleItems([]);
      setPaymentDialogOpen(false);
      showSnackbar("Payment successful! Thank you.");

      if (selectedBranch) {
        if (isWarehouseMode) {
          fetchWarehouseInventory();
        } else {
          fetchRetailInventory();
        }
      }
    } catch (error) {
      console.error("Error clearing cart:", error);
      showSnackbar("Payment completed but cart cleanup failed");
    }
  };

  const handleRemoveCartItem = async (index) => {
    const itemToRemove = cart[index];
    setCart(cart.filter((_, i) => i !== index));

    if (itemToRemove.dbId) {
      try {
        await generateAndExecuteMutation(
          "deleteCartItem",
          { id: itemToRemove.dbId },
          "item",
          sales_url,
        );
        showSnackbar("Item removed from cart");
      } catch (error) {
        console.error("Error deleting cart item from database:", error);
      }
    }
  };

  const checkShiftBalance = async () => {
    try {
      await fetchDataEngineBalance(
        "openingClosingBalance",
        "functionparams",
        { companyId, createdBy: userId, manualOpeningBalance: null },
        [
          "openingBalance",
          "closingBalance",
          "cashSales",
          "creditSales",
          "mpesaSales",
        ],
        salesManagement.uri,
      );
      setIsShiftOpen(true);
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Shift not started",
        text: "Please open a shift before making payments.",
      });
      setIsShiftOpen(false);
    }
  };

  useEffect(() => {
    checkShiftBalance();
  }, []);

  useEffect(() => {
    try {
      let stored = JSON.parse(localStorage.getItem("saleSettings") || "[]");
      if (typeof stored === "string") stored = JSON.parse(stored);
      const settings = Array.isArray(stored) ? stored : [];
      const isSettingTrue = (entryOrder) => {
        const setting = settings.find(
          (s) => (s.EntryOrder ?? s.entryOrder) === entryOrder,
        );
        const value = setting?.Value ?? setting?.value;
        return value?.toString().toLowerCase() === "true";
      };

      setHasService(isSettingTrue(1));
      setShowBuyingPrice(isSettingTrue(2));
      setRequireMpesaCodeForCash(isSettingTrue(3));
      setIsStraightSale(isSettingTrue(4));
    } catch (error) {
      console.error("Failed to read sale settings from localStorage:", error);
    }
  }, []);

  useEffect(() => {
    if (!isServiceMode) return;
    const fetchServiceProducts = async () => {
      try {
        const result = await graphqlQuery(
          allServiceProductsQuery,
          setupManagementUrl.uri,
        );
        setServiceProducts((result || []).filter((p) => p.isActive));
      } catch (error) {
        console.error("Failed to load service products:", error);
        showSnackbar("Failed to load service products");
      }
    };
    fetchServiceProducts();
  }, [isServiceMode]);

  const handleCreateSaleOrder = async () => {
    try {
      const regularItems = cart.filter(
        (item) => !item.isExternal && !item.isService,
      );
      const externalItems = cart.filter((item) => item.isExternal);
      const serviceItems = cart.filter((item) => item.isService);

      const hasExternalSale = externalItems.length > 0 ? 1 : 0;
      const externalSaleAmount = externalItems.reduce(
        (sum, item) => sum + (item.netAmount || item.totalPrice || 0),
        0,
      );

      let saleOrderItemsList = [];
      if (regularItems.length === 0 && serviceItems.length === 0) {
        saleOrderItemsList = [
          {
            branchId: parseInt(selectedBranch),
            hasExternalSale: hasExternalSale,
            externalSaleAmount: externalSaleAmount,
          },
        ];
      } else {
        const regularMapped = regularItems.map((item) => ({
          productId: item.productId,
          productCode: item.productCode,
          aliasProductName: item.aliasProductName || null,
          colorId: item.colorId || null,
          size: item.size || null,
          isWareHouse: item.isWarehouse === true ? 1 : 0,
          quantity: item.quantity ? parseFloat(item.quantity) : null,
          isWholesale: item.isWholesale === true ? 1 : 0,
          isDiscount: item.isDiscount ? 1 : 0,
          discountAmount: item.discountValue || 0,
          amount: item.originalAmount || item.totalPrice,
          netAmount: item.netAmount || item.totalPrice,
          branchId: parseInt(selectedBranch),
          uomid: item.UOMId || null,
          hasExternalSale: hasExternalSale,
          externalSaleAmount: hasExternalSale ? externalSaleAmount : 0,
          isPriceOverride: item.isPriceOverride ? 1 : 0,
          overridePrice: item.overridePrice || null,
          overrideAmount: item.overrideAmount || 0,
          createdDate: item.createdDate || null,
          isStraightSale: isStraightSale ? 1 : 0,
        }));

        const serviceMapped = serviceItems.map((item) => ({
          productId: item.productId,
          quantity: parseFloat(item.quantity),
          amount: item.originalAmount || item.totalPrice,
          netAmount: item.netAmount || item.totalPrice,
          branchId: parseInt(selectedBranch),
          uomid: item.UOMId || null,
          isService: 1,
          isWareHouse: 0,
          isWholesale: 0,
          isDiscount: item.isDiscount ? 1 : 0,
          discountAmount: item.discountValue || 0,
          hasExternalSale: hasExternalSale,
          externalSaleAmount: hasExternalSale ? externalSaleAmount : 0,
          isPriceOverride: 0,
          overridePrice: null,
          overrideAmount: 0,
        }));

        saleOrderItemsList = [...regularMapped, ...serviceMapped];
      }

      const response = await generateAndExecuteMutationOrders(
        "createSaleOrder",
        { saleOrderItemsList },
        null,
        salesManagement.uri,
      );

      if (response.createSaleOrder?.id) {
        const newOrderId = parseInt(response.createSaleOrder.id);
        localStorage.setItem("orderId", newOrderId);

        if (externalItems.length > 0) {
          await createExternalProducts(externalItems, newOrderId);
        }

        setSnackbarMessage(
          "Order created successfully! You can proceed to checkout.",
        );
        setSnackbarOpen(true);
        handleOpenPaymentDialog();
      } else {
        throw new Error("Failed to create order.");
      }
    } catch (error) {
      console.error("Error creating sale order:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to create the sale order. Please try again.",
      });
    }
  };

  const createExternalProducts = async (externalItems, saleOrderId) => {
    try {
      const createPromises = externalItems.map(async (item) => {
        const externalProductData = {
          product: item.externalSaleData.product,
          productCode:
            item.externalSaleData.productCode !== "N/A"
              ? item.externalSaleData.productCode
              : null,
          quantity: item.externalSaleData.quantity,
          amount: item.netAmount || item.externalSaleData.amount,
          color:
            item.externalSaleData.color !== "N/A"
              ? item.externalSaleData.color
              : null,
          size:
            item.externalSaleData.size !== "N/A"
              ? item.externalSaleData.size
              : null,
          branchId: parseInt(selectedBranch),
          saleOrderId: saleOrderId,
        };

        return generateAndExecuteMutation(
          "createExternalProduct",
          externalProductData,
          "externalProduct",
          salesManagement.uri,
        );
      });

      await Promise.all(createPromises);
    } catch (error) {
      console.error("Error creating external products:", error);
      showSnackbar(
        "Warning: Some external products may not have been recorded",
      );
    }
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const getStockStatus = (item) => {
    const qty = isWarehouseMode ? item.cartons : item.totalQuantity;
    if (qty === 0)
      return { color: "error", label: "Out of Stock", chipColor: "#f44336" };
    if (qty < 5)
      return { color: "warning", label: "Low Stock", chipColor: "#ff9800" };
    return { color: "success", label: "In Stock", chipColor: "#4caf50" };
  };

  const currentInventory = isWarehouseMode
    ? warehouseInventory
    : searchQuery.trim()
      ? searchResults
      : retailInventory;
  const displayedInventory = (currentInventory || []).filter((item) => {
  if (!item) return false;
  const q = searchQuery.toLowerCase();
  return (
    (item.productName ?? "").toLowerCase().includes(q) ||
    (item.productCode ?? "").toLowerCase().includes(q) ||
    (item.aliasProductName ?? "").toLowerCase().includes(q)
  );
});

 const displayedServiceProducts = isServiceMode
  ? serviceProducts.filter(
      (p) =>
        !searchQuery.trim() ||
        (p.productName ?? "").toLowerCase().includes(searchQuery.toLowerCase()) ||
        (p.productCategory ?? "").toLowerCase().includes(searchQuery.toLowerCase()),
    )
  : [];
      const renderCartContent = () => (
  <>
    <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
      {cart.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#7F8C8D",
          }}
        >
          <ShoppingCartIcon sx={{ fontSize: 64, mb: 2 }} />
          <Typography variant="h6">Cart is empty</Typography>
          <Typography variant="body2">Add items to get started</Typography>
        </Box>
      ) : (
        <List>
          {cart.map((item, index) => (
            <Paper
              key={item.id}
              elevation={2}
              sx={{
                mb: 2,
                p: 2,
                bgcolor: isDark ? colors.primary[400] : "white",
                border: item.isDiscount
                  ? "2px solid #27AE60"
                  : item.isPriceOverride
                    ? "2px solid #FF7043"
                    : item.isExternal || item.isExternalBranch
                      ? "2px solid #27AE60"
                      : isDark
                        ? `1px solid ${colors.primary[300]}`
                        : "1px solid #E0E0E0",
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                    <Typography variant="subtitle1" fontWeight="600">
                      {item.productName}
                    </Typography>
                    {(item.isExternal || item.isExternalBranch) && (
                      <Chip
                        icon={<BusinessIcon sx={{ fontSize: 12 }} />}
                        label="External"
                        size="small"
                        sx={{ bgcolor: "#27AE60", color: "white", height: 20, fontSize: 10 }}
                      />
                    )}
                    {item.isService && (
                      <Chip
                        icon={<StyleIcon sx={{ fontSize: 12 }} />}
                        label="Service"
                        size="small"
                        sx={{ bgcolor: lightBlue.main, color: "white", height: 20, fontSize: 10 }}
                      />
                    )}
                  </Box>
                  <Typography variant="caption" color="text.secondary">
                    {item.productCode}
                    {item.colorName && ` • ${item.colorName}`}
                    {item.size && ` • Size ${item.size}`}
                    {item.sizeRange && ` • ${item.sizeRange}`}
                  </Typography>
                </Box>
                <IconButton size="small" onClick={() => handleRemoveCartItem(index)} color="error">
                  <DeleteIcon />
                </IconButton>
              </Box>

              <Divider sx={{ my: 1 }} />

              <Box sx={{ mb: 1 }}>
                <Typography variant="body2">
                  Quantity: <strong>{item.quantity}</strong>
                </Typography>

                {item.isPriceOverride && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <TrendingUpIcon sx={{ fontSize: 16, color: "#FF7043" }} />
                    <Typography variant="body2" sx={{ color: "#FF7043", fontWeight: 600 }}>
                      Override: +KSh {item.overrideAmount.toFixed(2)}
                    </Typography>
                  </Box>
                )}

                {item.isDiscount ? (
                  <>
                    <Typography variant="body2" sx={{ textDecoration: "line-through", color: "text.secondary" }}>
                      Original: KSh {(item.originalAmount || item.totalPrice).toFixed(2)}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <DiscountIcon sx={{ fontSize: 16, color: "#27AE60" }} />
                      <Typography variant="body2" sx={{ color: "#27AE60", fontWeight: 600 }}>
                        Discount: KSh {item.discountValue.toFixed(2)}
                      </Typography>
                    </Box>
                    <Typography variant="h6" sx={{ color: "#27AE60", fontWeight: 700 }}>
                      Net: KSh {item.netAmount.toFixed(2)}
                    </Typography>
                  </>
                ) : (
                  <Typography variant="h6" fontWeight="700">
                    KSh {item.totalPrice.toFixed(2)}
                  </Typography>
                )}
              </Box>

              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  fullWidth
                  size="small"
                  variant={item.isDiscount ? "contained" : "outlined"}
                  startIcon={<DiscountIcon />}
                  onClick={() => handleOpenDiscountDialog(index)}
                  sx={{
                    bgcolor: item.isDiscount ? "#27AE60" : "transparent",
                    color: item.isDiscount ? "white" : "#27AE60",
                    borderColor: "#27AE60",
                    "&:hover": { bgcolor: item.isDiscount ? "#229954" : "#E8F5E9" },
                  }}
                >
                  {item.isDiscount ? "Edit" : "Discount"}
                </Button>

                {canApplyPriceOverride && !item.isExternal && (
                  <Button
                    fullWidth
                    size="small"
                    variant={item.isPriceOverride ? "contained" : "outlined"}
                    startIcon={<TrendingUpIcon />}
                    onClick={() => handleOpenPriceOverrideDialog(index)}
                    sx={{
                      bgcolor: item.isPriceOverride ? "#FF7043" : "transparent",
                      color: item.isPriceOverride ? "white" : "#FF7043",
                      borderColor: "#FF7043",
                      "&:hover": { bgcolor: item.isPriceOverride ? "#F4511E" : "#FBE9E7" },
                    }}
                  >
                    {item.isPriceOverride ? "Edit" : "Override"}
                  </Button>
                )}
              </Box>
            </Paper>
          ))}
        </List>
      )}
    </Box>

    <Box sx={{ p: 2, bgcolor: isDark ? colors.primary[400] : "#D5DBDB" }}>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="body1">Subtotal:</Typography>
          <Typography variant="body1" fontWeight="600">
            KSh {cart.reduce((sum, item) => sum + (item.originalAmount || item.totalPrice), 0).toFixed(2)}
          </Typography>
        </Box>

        {cart.some((item) => item.isPriceOverride) && (
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, color: "#FF7043" }}>
            <Typography variant="body1">Price Overrides:</Typography>
            <Typography variant="body1" fontWeight="600">
              + KSh {cart.reduce((sum, item) => sum + (item.overrideAmount || 0), 0).toFixed(2)}
            </Typography>
          </Box>
        )}

        {cart.some((item) => item.isDiscount) && (
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, color: "#27AE60" }}>
            <Typography variant="body1">Total Discounts:</Typography>
            <Typography variant="body1" fontWeight="600">
              - KSh {cart.reduce((sum, item) => sum + (item.discountValue || 0), 0).toFixed(2)}
            </Typography>
          </Box>
        )}

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" fontWeight="700">Total:</Typography>
          <Typography variant="h6" fontWeight="700" color="primary">
            KSh {cart.reduce((sum, item) => sum + (item.netAmount || item.totalPrice), 0).toFixed(2)}
          </Typography>
        </Box>
      </Box>

      <Button
        fullWidth
        variant="contained"
        size="large"
        color="success"
        onClick={handleCreateSaleOrder}
        disabled={cart.length === 0}
        sx={{ py: 2, fontSize: "1.1rem", fontWeight: "700" }}
      >
        CHECKOUT ({cart.length} items)
      </Button>
    </Box>
  </>
);


  const selectedBranchName =
    branches.find((b) => b.id === selectedBranch)?.branchName || "";

  // Continue to Part 2 for the JSX return statement...

  // ============================================
  // JSX RETURN STATEMENT - Part 2
  // ============================================
  // This continues from Part 1 - combine both parts into one file

  return (
    <Box
      sx={{
        height: "120vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: isDark ? colors.primary[500] : "#F8F9FA",
      }}
    >
      {isLoadingCart && (
        <Box sx={{ p: 2, bgcolor: lightBlue.lighter, textAlign: "center" }}>
          <CircularProgress size={20} sx={{ mr: 1 }} />
          <Typography variant="body2" component="span">
            Restoring your cart...
          </Typography>
        </Box>
      )}

      {/* Header */}
      <Paper
        elevation={2}
        sx={{ p: 2, bgcolor: lightBlue.header, borderRadius: 0 }}
      >
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={12} md={4}>
            <Typography variant="h3" fontWeight="600" color="white">
              {isServiceMode ? (
                <>
                  <StyleIcon
                    sx={{ mr: 1, fontSize: 32, verticalAlign: "middle" }}
                  />
                  Service POS
                </>
              ) : isWarehouseMode ? (
                <>
                  <LocalShippingIcon
                    sx={{ mr: 1, fontSize: 32, verticalAlign: "middle" }}
                  />
                  Warehouse POS
                </>
              ) : (
                <>
                  <StorefrontIcon
                    sx={{ mr: 1, fontSize: 32, verticalAlign: "middle" }}
                  />
                  Retail POS
                </>
              )}
            </Typography>
          </Grid>

          {(canSellAtWarehouse || hasService) && (
            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small">
                <Select
                  value={
                    isServiceMode
                      ? "service"
                      : isWarehouseMode
                        ? "warehouse"
                        : "retail"
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    if (val === "service") {
                      setIsServiceMode(true);
                      setIsWarehouseMode(false);
                    } else {
                      setIsServiceMode(false);
                      setIsWarehouseMode(val === "warehouse");
                    }
                    setSelectedBranch("");
                    setCart([]);
                  }}
                  sx={{
                    bgcolor: isDark ? colors.primary[400] : "white",
                    fontWeight: "600",
                  }}
                >
                  {canSellAtWarehouse && (
                    <MenuItem value="warehouse">
                      <LocalShippingIcon sx={{ mr: 1, fontSize: 18 }} />
                      Warehouse Mode
                    </MenuItem>
                  )}
                  <MenuItem value="retail">
                    <StorefrontIcon sx={{ mr: 1, fontSize: 18 }} />
                    Retail Mode
                  </MenuItem>
                  {hasService && (
                    <MenuItem value="service">
                      <StyleIcon sx={{ mr: 1, fontSize: 18 }} />
                      Service Sale
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} md={canSellAtWarehouse || hasService ? 4 : 8}>
            <FormControl fullWidth size="small">
              <InputLabel
                sx={{ color: "white", "&.Mui-focused": { color: "white" } }}
              >
                Select {isWarehouseMode ? "Warehouse" : "Branch"}
              </InputLabel>
              <Select
                value={selectedBranch}
                label={`Select ${isWarehouseMode ? "Warehouse" : "Branch"}`}
                onChange={handleBranchChange}
                sx={{ bgcolor: isDark ? colors.primary[400] : "white" }}
              >
                {branches.map((branch) => (
                  <MenuItem key={branch.id} value={branch.id}>
                    {branch.branchName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Main Content */}
      <Box sx={{ flex: 1, display: "flex", overflow: "hidden" }}>
        {/* Inventory Section */}
        <Box
          sx={{
            flex: isMobile ? 1 : 2,
            p: 2,
            overflowY: "auto",
            bgcolor: isDark ? colors.primary[500] : "#F8F9FA",
          }}
        >
          {/* Search Bar */}
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={2} alignItems="stretch">
              <Grid item xs={12} md>
                <Paper
                  elevation={1}
                  sx={{
                    p: 1.5,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    height: "100%",
                    bgcolor: isDark ? colors.primary[400] : "white",
                  }}
                >
                  <TextField
                    fullWidth
                    placeholder="Search by product name or code..."
                    variant="outlined"
                    size="medium"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: "#7F8C8D" }} />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {isSearching && (
                            <CircularProgress size={18} color="inherit" />
                          )}
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: isDark ? colors.primary[400] : "#F8F9FA",
                        "&:hover": {
                          bgcolor: isDark ? colors.primary[300] : "#F1F3F4",
                        },
                        "&.Mui-focused": {
                          bgcolor: isDark ? colors.primary[400] : "white",
                        },
                      },
                    }}
                  />

                  {/* Integrated Limit Selector (retail only) */}
                  {!isWarehouseMode && (
                    <>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ mx: 0.5 }}
                      />
                      <FormControl size="medium" sx={{ minWidth: 100 }}>
                        <Select
                          value={searchLimit}
                          onChange={(e) => setSearchLimit(e.target.value)}
                          displayEmpty
                          sx={{
                            bgcolor: isDark ? colors.primary[400] : "#F8F9FA",
                            "&:hover": {
                              bgcolor: isDark ? colors.primary[300] : "#F1F3F4",
                            },
                            "& .MuiSelect-select": {
                              py: 1.5,
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                          renderValue={(value) => (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                Show:
                              </Typography>
                              <Typography variant="body2" fontWeight={600}>
                                {value}
                              </Typography>
                            </Box>
                          )}
                        >
                          <MenuItem value={5}>5 results</MenuItem>
                          <MenuItem value={10}>10 results</MenuItem>
                          <MenuItem value={25}>25 results</MenuItem>
                          <MenuItem value={50}>50 results</MenuItem>
                          <MenuItem value={100}>100 results</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}
                </Paper>
              </Grid>

              {/* Due Stock Button */}
              <Grid item xs="auto">
                <Tooltip title="Due Stock" arrow>
                  <Button
                    variant="contained"
                    onClick={handleOpenDueStockDialog}
                    disabled={!selectedBranch || isLoadingDueStock}
                    sx={{
                      height: "100%",
                      minWidth: 48,
                      px: 2,
                      bgcolor: "#FF9800",
                      "&:hover": { bgcolor: "#F57C00" },
                    }}
                  >
                    {isLoadingDueStock ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      <WarningIcon />
                    )}
                  </Button>
                </Tooltip>
              </Grid>

              {!isWarehouseMode && !isServiceMode && (
                <Grid item xs="auto">
                  <Tooltip title="External Sale" arrow>
                    <Button
                      variant="contained"
                      onClick={handleOpenExternalSaleDialog}
                      sx={{
                        height: "100%",
                        minWidth: 48,
                        px: 2,
                        bgcolor: "#27AE60",
                        "&:hover": { bgcolor: "#229954" },
                      }}
                    >
                      <AddBusinessIcon />
                    </Button>
                  </Tooltip>
                </Grid>
              )}
            </Grid>
          </Box>

          {/* Inventory Grid */}
          <Grid container spacing={2}>
            {isServiceMode
              ? displayedServiceProducts.map((product) => (
                  <Grid item xs={12} sm={6} lg={4} key={product.id}>
                    <Card
                      elevation={2}
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          transform: "translateY(-4px)",
                          boxShadow: 6,
                        },
                        bgcolor: isDark ? colors.primary[400] : "white",
                        borderTop: `3px solid ${lightBlue.main}`,
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "start",
                            mb: 1,
                          }}
                        >
                          <Typography
                            variant="h6"
                            fontWeight="600"
                            sx={{ flex: 1 }}
                          >
                            {product.productName}
                          </Typography>
                          <Chip
                            icon={<StyleIcon sx={{ fontSize: 12 }} />}
                            label="Service"
                            size="small"
                            sx={{
                              bgcolor: lightBlue.main,
                              color: "white",
                              fontWeight: "600",
                            }}
                          />
                        </Box>

                        {product.productCategory && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            gutterBottom
                          >
                            Category: <strong>{product.productCategory}</strong>
                          </Typography>
                        )}

                        <Divider sx={{ my: 1 }} />

                        <Box sx={{ mt: 2 }}>
                          <Typography
                            variant="h5"
                            fontWeight="700"
                            sx={{ color: lightBlue.dark }}
                          >
                            KSh{" "}
                            {(
                              product.unitPrice ||
                              product.retailPrice ||
                              0
                            ).toFixed(2)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            per {product.unitofMeasure || "unit"}
                          </Typography>
                          {showBuyingPrice && product.costPrice > 0 && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: "block", mt: 0.5 }}
                            >
                              BP: KSh{" "}
                              <strong>
                                {(product.costPrice ?? 0).toFixed(2)}
                              </strong>
                            </Typography>
                          )}
                        </Box>
                      </CardContent>

                      <CardActions sx={{ p: 2, pt: 0 }}>
                        <Button
                          fullWidth
                          variant="contained"
                          size="small"
                          startIcon={<AddIcon />}
                          onClick={() => handleOpenServiceQuickAdd(product)}
                          sx={{
                            py: 1.5,
                            fontWeight: "600",
                            fontSize: "0.5rem",
                            bgcolor: lightBlue.main,
                            "&:hover": { bgcolor: lightBlue.dark },
                          }}
                        >
                          Add to Cart
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))
              : displayedInventory.map((item) => {
                  const stockStatus = getStockStatus(item);
                  const qty = isWarehouseMode
                    ? item.cartons
                    : item.totalQuantity;
                 const isPieceMode = companyId === 1037 || companyId === 1036 ;

                  const priceLabel = isWarehouseMode
                    ? "per carton"
                    : isPieceMode
                      ? "per piece"
                      : "per pair";

                  const qtyLabel = isWarehouseMode
                    ? "cartons"
                    : isPieceMode
                      ? "pieces"
                      : "pairs";

                  return (
                    <Grid item xs={12} sm={6} lg={4} key={item.id}>
                      <Card
                        elevation={2}
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          transition: "transform 0.2s, box-shadow 0.2s",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: 6,
                          },
                          bgcolor: isDark ? colors.primary[400] : "white",
                        }}
                      >
                        <CardContent sx={{ flexGrow: 1, pb: 1 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "start",
                              mb: 1,
                            }}
                          >
                            <Typography
                              variant="h6"
                              fontWeight="600"
                              sx={{ flex: 1 }}
                            >
                              {item.productName}
                            </Typography>
                            <Chip
                              size="small"
                              label={stockStatus.label}
                              sx={{
                                bgcolor: stockStatus.chipColor,
                                color: "white",
                                fontWeight: "600",
                              }}
                            />
                          </Box>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                            gutterBottom
                          >
                            Code: <strong>{item.productCode}</strong>
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            gutterBottom
                          >
                            Alias: <strong>{item.aliasProductName}</strong>
                          </Typography>

                          <Divider sx={{ my: 1 }} />

                          <Box sx={{ mt: 2 }}>
                            <Typography
                              variant="h5"
                              color="primary"
                              fontWeight="700"
                              sx={{ color: lightBlue.dark }}
                            >
                              KSh{" "}
                              {isWarehouseMode
                                ? (
                                    item.averageSP ??
                                    item.sellingPricePerCarton ??
                                    0
                                  ).toFixed(2)
                                : (item.averageSellingPrice ?? 0).toFixed(2)}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {priceLabel}
                            </Typography>
                            {showBuyingPrice && (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                BP: KSh{" "}
                                <strong>
                                  {isWarehouseMode
                                    ? (
                                        item.averageBP ??
                                        item.averageBpPerPair ??
                                        0
                                      ).toFixed(2)
                                    : (item.averageBuyingPrice ?? 0).toFixed(2)}
                                </strong>
                              </Typography>
                            )}
                          </Box>

                          <Box
                            sx={{
                              mt: 2,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <InventoryIcon
                              sx={{
                                fontSize: 18,
                                mr: 0.5,
                                color: stockStatus.chipColor,
                              }}
                            />
                            <Typography variant="body2" color="text.secondary">
                              {qty} {qtyLabel} available
                            </Typography>
                          </Box>
                        </CardContent>

                        <CardActions sx={{ p: 2, pt: 0 }}>
                          <Button
                            fullWidth
                            variant="contained"
                            size="small"
                            startIcon={
                              isStraightSale ? <AddIcon /> : <VisibilityIcon />
                            }
                            onClick={() =>
                              isStraightSale
                                ? handleOpenStraightSaleQuickAdd(item)
                                : handleOpenDetailsDialog(item)
                            }
                            sx={{
                              py: 1.5,
                              fontWeight: "600",
                              fontSize: "0.5rem",
                              bgcolor: lightBlue.main,
                              "&:hover": { bgcolor: lightBlue.dark },
                            }}
                          >
                            {isStraightSale ? "Add" : "View"}
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })}
          </Grid>
        </Box>

        {/* Cart Section */}
        {!isMobile && (
          <Paper
            elevation={3}
            sx={{
              width: 450,
              display: "flex",
              flexDirection: "column",
              bgcolor: isDark ? colors.primary[500] : "#ECF0F1",
              borderRadius: 0,
            }}
          >
            <Box sx={{ p: 2, bgcolor: lightBlue.light }}>
              <Typography variant="h5" fontWeight="600" color="white">
                <Badge badgeContent={cart.length} color="error">
                  <ShoppingCartIcon />
                </Badge>
                <span style={{ marginLeft: 12 }}>Current Order</span>
              </Typography>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
              {cart.length === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    color: "#7F8C8D",
                  }}
                >
                  <ShoppingCartIcon sx={{ fontSize: 64, mb: 2 }} />
                  <Typography variant="h6">Cart is empty</Typography>
                  <Typography variant="body2">
                    Add items to get started
                  </Typography>
                </Box>
              ) : (
                <List>
                  {cart.map((item, index) => (
                    <Paper
                      key={item.id}
                      elevation={2}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: isDark ? colors.primary[400] : "white",
                        border: item.isDiscount
                          ? "2px solid #27AE60"
                          : item.isPriceOverride
                            ? "2px solid #FF7043"
                            : item.isExternal || item.isExternalBranch
                              ? "2px solid #27AE60"
                              : isDark
                                ? `1px solid ${colors.primary[300]}`
                                : "1px solid #E0E0E0",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              flexWrap: "wrap",
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight="600">
                              {item.productName}
                            </Typography>
                            {/* ✅ External flag */}
                            {(item.isExternal || item.isExternalBranch) && (
                              <Chip
                                icon={<BusinessIcon sx={{ fontSize: 12 }} />}
                                label="External"
                                size="small"
                                sx={{
                                  bgcolor: "#27AE60",
                                  color: "white",
                                  height: 20,
                                  fontSize: 10,
                                }}
                              />
                            )}
                            {/* Service flag */}
                            {item.isService && (
                              <Chip
                                icon={<StyleIcon sx={{ fontSize: 12 }} />}
                                label="Service"
                                size="small"
                                sx={{
                                  bgcolor: lightBlue.main,
                                  color: "white",
                                  height: 20,
                                  fontSize: 10,
                                }}
                              />
                            )}
                          </Box>
                          <Typography variant="caption" color="text.secondary">
                            {item.productCode}
                            {item.colorName && ` • ${item.colorName}`}
                            {item.size && ` • Size ${item.size}`}
                            {item.sizeRange && ` • ${item.sizeRange}`}
                          </Typography>
                        </Box>
                        <IconButton
                          size="small"
                          onClick={() => handleRemoveCartItem(index)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>

                      <Divider sx={{ my: 1 }} />

                      <Box sx={{ mb: 1 }}>
                        <Typography variant="body2">
                          Quantity: <strong>{item.quantity}</strong>
                        </Typography>

                        {/* ✅ Price Override indicator */}
                        {item.isPriceOverride && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <TrendingUpIcon
                              sx={{ fontSize: 16, color: "#FF7043" }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: "#FF7043", fontWeight: 600 }}
                            >
                              Override: +KSh {item.overrideAmount.toFixed(2)}
                            </Typography>
                          </Box>
                        )}

                        {item.isDiscount ? (
                          <>
                            <Typography
                              variant="body2"
                              sx={{
                                textDecoration: "line-through",
                                color: "text.secondary",
                              }}
                            >
                              Original: KSh{" "}
                              {(item.originalAmount || item.totalPrice).toFixed(
                                2,
                              )}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <DiscountIcon
                                sx={{ fontSize: 16, color: "#27AE60" }}
                              />
                              <Typography
                                variant="body2"
                                sx={{ color: "#27AE60", fontWeight: 600 }}
                              >
                                Discount: KSh {item.discountValue.toFixed(2)}
                              </Typography>
                            </Box>
                            <Typography
                              variant="h6"
                              sx={{ color: "#27AE60", fontWeight: 700 }}
                            >
                              Net: KSh {item.netAmount.toFixed(2)}
                            </Typography>
                          </>
                        ) : (
                          <Typography variant="h6" fontWeight="700">
                            KSh {item.totalPrice.toFixed(2)}
                          </Typography>
                        )}
                      </Box>

                      {/* Action buttons */}
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Button
                          fullWidth
                          size="small"
                          variant={item.isDiscount ? "contained" : "outlined"}
                          startIcon={<DiscountIcon />}
                          onClick={() => handleOpenDiscountDialog(index)}
                          sx={{
                            bgcolor: item.isDiscount
                              ? "#27AE60"
                              : "transparent",
                            color: item.isDiscount ? "white" : "#27AE60",
                            borderColor: "#27AE60",
                            "&:hover": {
                              bgcolor: item.isDiscount ? "#229954" : "#E8F5E9",
                            },
                          }}
                        >
                          {item.isDiscount ? "Edit" : "Discount"}
                        </Button>

                        {/* ✅ Price Override Button */}
                        {canApplyPriceOverride && !item.isExternal && (
                          <Button
                            fullWidth
                            size="small"
                            variant={
                              item.isPriceOverride ? "contained" : "outlined"
                            }
                            startIcon={<TrendingUpIcon />}
                            onClick={() => handleOpenPriceOverrideDialog(index)}
                            sx={{
                              bgcolor: item.isPriceOverride
                                ? "#FF7043"
                                : "transparent",
                              color: item.isPriceOverride ? "white" : "#FF7043",
                              borderColor: "#FF7043",
                              "&:hover": {
                                bgcolor: item.isPriceOverride
                                  ? "#F4511E"
                                  : "#FBE9E7",
                              },
                            }}
                          >
                            {item.isPriceOverride ? "Edit" : "Override"}
                          </Button>
                        )}
                      </Box>
                    </Paper>
                  ))}
                </List>
              )}
            </Box>

            {/* Cart Summary */}
            <Box
              sx={{ p: 2, bgcolor: isDark ? colors.primary[400] : "#D5DBDB" }}
            >
              <Box sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body1">Subtotal:</Typography>
                  <Typography variant="body1" fontWeight="600">
                    KSh{" "}
                    {cart
                      .reduce(
                        (sum, item) =>
                          sum + (item.originalAmount || item.totalPrice),
                        0,
                      )
                      .toFixed(2)}
                  </Typography>
                </Box>

                {/* Price overrides total */}
                {cart.some((item) => item.isPriceOverride) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                      color: "#FF7043",
                    }}
                  >
                    <Typography variant="body1">Price Overrides:</Typography>
                    <Typography variant="body1" fontWeight="600">
                      + KSh{" "}
                      {cart
                        .reduce(
                          (sum, item) => sum + (item.overrideAmount || 0),
                          0,
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>
                )}

                {/* Discounts total */}
                {cart.some((item) => item.isDiscount) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                      color: "#27AE60",
                    }}
                  >
                    <Typography variant="body1">Total Discounts:</Typography>
                    <Typography variant="body1" fontWeight="600">
                      - KSh{" "}
                      {cart
                        .reduce(
                          (sum, item) => sum + (item.discountValue || 0),
                          0,
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>
                )}

                <Divider sx={{ my: 1 }} />

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h6" fontWeight="700">
                    Total:
                  </Typography>
                  <Typography variant="h6" fontWeight="700" color="primary">
                    KSh{" "}
                    {cart
                      .reduce(
                        (sum, item) =>
                          sum + (item.netAmount || item.totalPrice),
                        0,
                      )
                      .toFixed(2)}
                  </Typography>
                </Box>
              </Box>

              <Button
                fullWidth
                variant="contained"
                size="large"
                color="success"
                onClick={handleCreateSaleOrder}
                disabled={cart.length === 0}
                sx={{ py: 2, fontSize: "1.1rem", fontWeight: "700" }}
              >
                CHECKOUT ({cart.length} items)
              </Button>
            </Box>
          </Paper>
        )}
      </Box>
   {isMobile && (
            <>
              <Paper
                elevation={3}
                sx={{ position: "fixed", bottom: 0, left: 0, right: 0, p: 2, zIndex: 1000 }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  color="success"
                  onClick={() => setMobileCartOpen(true)}
                  startIcon={<ShoppingCartIcon />}
                  sx={{ py: 2, fontSize: "1.1rem", fontWeight: "700" }}
                >
                  VIEW CART ({cart.length} items) — KSh{" "}
                  {cart.reduce((sum, item) => sum + (item.netAmount || item.totalPrice), 0).toFixed(2)}
                </Button>
              </Paper>

              <Drawer
                anchor="bottom"
                open={mobileCartOpen}
                onClose={() => setMobileCartOpen(false)}
                PaperProps={{ sx: { height: "85vh", borderRadius: "16px 16px 0 0" } }}
              >
                <Box sx={{ p: 2, bgcolor: lightBlue.light, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <Typography variant="h5" fontWeight="600" color="white">
                    <Badge badgeContent={cart.length} color="error">
                      <ShoppingCartIcon />
                    </Badge>
                    <span style={{ marginLeft: 12 }}>Current Order</span>
                  </Typography>
                  <IconButton onClick={() => setMobileCartOpen(false)} sx={{ color: "white" }}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                {renderCartContent()}
              </Drawer>
            </>
          )}
      {/* Mobile Cart Button */}
      {/* {isMobile && (
        <Paper
          elevation={3}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            p: 2,
            zIndex: 1000,
          }}
        >
          <Button
            fullWidth
            variant="contained"
            size="large"
            color="success"
            onClick={handleCreateSaleOrder}
            disabled={cart.length === 0}
            startIcon={<ShoppingCartIcon />}
            sx={{ py: 2, fontSize: "1.1rem", fontWeight: "700" }}
          >
            CHECKOUT ({cart.length} items)
          </Button>
        </Paper>
      )} */}

      {/* Details Dialog */}
      <ImprovedDetailsDialog
        open={openDetailsDialog}
        onClose={resetDetailsDialog}
        selectedProduct={selectedProduct}
        inventoryDetails={inventoryDetails}
        isWarehouseMode={isWarehouseMode}
        onAddToCart={handleAddToCart}
        lightBlue={lightBlue}
      />

      {/* ✅ Price Override Dialog */}
      <Dialog
        open={priceOverrideDialogOpen}
        onClose={handleClosePriceOverrideDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF7043",
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <TrendingUpIcon sx={{ mr: 1 }} />
          Price Override
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          {selectedCartItemForOverride && (
            <>
              <Paper elevation={2} sx={{ p: 2, mb: 3, bgcolor: "#F8F9FA" }}>
                <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                  {selectedCartItemForOverride.item.productName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Code: {selectedCartItemForOverride.item.productCode}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">Quantity:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    {selectedCartItemForOverride.item.quantity}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">Default Price/Unit:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    KSh{" "}
                    {(
                      selectedCartItemForOverride.item.originalSellingPrice ||
                      (selectedCartItemForOverride.item.isWarehouse
                        ? selectedCartItemForOverride.item.averageSP
                        : selectedCartItemForOverride.item.averageSellingPrice)
                    ).toFixed(2)}
                  </Typography>
                </Box>
              </Paper>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={applyOverride}
                    onChange={(e) => setApplyOverride(e.target.checked)}
                    sx={{
                      color: "#FF7043",
                      "&.Mui-checked": { color: "#FF7043" },
                    }}
                  />
                }
                label={
                  <Typography variant="body1" fontWeight="600">
                    Apply Price Override
                  </Typography>
                }
                sx={{ mb: 2 }}
              />

              {applyOverride && (
                <>
                  <TextField
                    fullWidth
                    required
                    type="number"
                    label="New Price per Unit (KSh)"
                    value={overridePrice}
                    onChange={(e) => setOverridePrice(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">KSh</InputAdornment>
                      ),
                    }}
                    sx={{ mb: 2 }}
                  />

                  {overridePrice && parseFloat(overridePrice) > 0 && (
                    <Paper
                      elevation={2}
                      sx={{
                        p: 2,
                        bgcolor: "#FFF3E0",
                        border: "2px solid #FF7043",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight="600"
                        gutterBottom
                      >
                        Summary:
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mb: 1,
                        }}
                      >
                        <Typography variant="body2">New Total:</Typography>
                        <Typography
                          variant="body1"
                          fontWeight="700"
                          sx={{ color: "#FF7043" }}
                        >
                          KSh{" "}
                          {(
                            parseFloat(overridePrice) *
                            selectedCartItemForOverride.item.quantity
                          ).toFixed(2)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2">
                          Override Amount:
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="600"
                          sx={{ color: "#FF7043" }}
                        >
                          +KSh{" "}
                          {(
                            (parseFloat(overridePrice) -
                              (selectedCartItemForOverride.item
                                .originalSellingPrice ||
                                (selectedCartItemForOverride.item.isWarehouse
                                  ? selectedCartItemForOverride.item.averageSP
                                  : selectedCartItemForOverride.item
                                      .averageSellingPrice))) *
                            selectedCartItemForOverride.item.quantity
                          ).toFixed(2)}
                        </Typography>
                      </Box>
                    </Paper>
                  )}
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClosePriceOverrideDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleApplyPriceOverride}
            variant="contained"
            sx={{
              bgcolor: applyOverride ? "#FF7043" : lightBlue.main,
              "&:hover": {
                bgcolor: applyOverride ? "#F4511E" : lightBlue.dark,
              },
            }}
          >
            {applyOverride ? "Apply Override" : "Remove Override"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Discount Dialog */}
      <Dialog
        open={discountDialogOpen}
        onClose={handleCloseDiscountDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: lightBlue.main,
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <DiscountIcon sx={{ mr: 1 }} />
          Apply Discount
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          {selectedCartItemForDiscount && (
            <>
              <Paper elevation={2} sx={{ p: 2, mb: 3, bgcolor: "#F8F9FA" }}>
                <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                  {selectedCartItemForDiscount.item.productName}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">Original Amount:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    KSh{" "}
                    {(
                      selectedCartItemForDiscount.item.originalAmount ||
                      selectedCartItemForDiscount.item.totalPrice
                    ).toFixed(2)}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Cost Price:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    KSh{" "}
                    {(
                      calculateBuyingPrice(selectedCartItemForDiscount.item) *
                      selectedCartItemForDiscount.item.quantity
                    ).toFixed(2)}
                  </Typography>
                </Box>
              </Paper>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={applyDiscount}
                    onChange={(e) => setApplyDiscount(e.target.checked)}
                    sx={{
                      color: lightBlue.main,
                      "&.Mui-checked": { color: lightBlue.main },
                    }}
                  />
                }
                label={
                  <Typography variant="body1" fontWeight="600">
                    Apply Discount
                  </Typography>
                }
                sx={{ mb: 2 }}
              />

              {canOverrideCostPrice && applyDiscount && (
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    mb: 2,
                    bgcolor: "#FFF3CD",
                    border: "2px solid #FFC107",
                    borderRadius: 2,
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={allowBelowCostPrice}
                        onChange={(e) =>
                          setAllowBelowCostPrice(e.target.checked)
                        }
                        sx={{
                          color: "#FF6F00",
                          "&.Mui-checked": { color: "#FF6F00" },
                        }}
                      />
                    }
                    label={
                      <Box>
                        <Typography variant="body2" fontWeight="600">
                          Allow Selling Below Cost Price
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          ⚠️ Enable to allow discounts that result in losses
                        </Typography>
                      </Box>
                    }
                  />
                </Paper>
              )}

              {applyDiscount && (
                <TextField
                  fullWidth
                  required
                  type="number"
                  label="Discount Amount (KSh)"
                  value={discountAmount}
                  onChange={(e) => setDiscountAmount(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">KSh</InputAdornment>
                    ),
                  }}
                  sx={{ mb: 2 }}
                />
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseDiscountDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleApplyDiscount}
            variant="contained"
            sx={{
              bgcolor: applyDiscount ? "#27AE60" : lightBlue.main,
              "&:hover": {
                bgcolor: applyDiscount ? "#229954" : lightBlue.dark,
              },
            }}
          >
            {applyDiscount ? "Apply Discount" : "Remove Discount"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* External Sale Dialog */}
      <Dialog
        open={externalSaleDialogOpen}
        onClose={handleCloseExternalSaleDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: lightBlue.main, color: "white" }}>
          <AddBusinessIcon sx={{ mr: 1, verticalAlign: "middle" }} />
          Record External Sale
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper elevation={2} sx={{ p: 2, bgcolor: "#F8F9FA" }}>
                <Typography variant="h6" gutterBottom>
                  Add Item
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      label="Product Name"
                      value={externalSaleForm.product}
                      onChange={(e) =>
                        handleExternalSaleFormChange("product", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Product Code"
                      value={externalSaleForm.productCode}
                      onChange={(e) =>
                        handleExternalSaleFormChange(
                          "productCode",
                          e.target.value,
                        )
                      }
                      InputProps={{
                        endAdornment: isValidatingProductCode ? (
                          <CircularProgress size={20} />
                        ) : productCodeValidation.isValid === true ? (
                          <CheckCircleIcon color="success" />
                        ) : productCodeValidation.hasStock === true ? (
                          <ErrorIcon color="error" />
                        ) : null,
                      }}
                      error={productCodeValidation.hasStock === true}
                    />
                    {productCodeValidation.message && (
                      <Alert
                        severity={
                          productCodeValidation.hasStock
                            ? "error"
                            : productCodeValidation.isValid
                              ? "success"
                              : "warning"
                        }
                        sx={{ mt: 1 }}
                      >
                        {productCodeValidation.message}
                      </Alert>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      label="Quantity"
                      value={externalSaleForm.quantity}
                      onChange={(e) =>
                        handleExternalSaleFormChange("quantity", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      label="Price Per Unit (KSh)"
                      value={externalSaleForm.amount}
                      onChange={(e) =>
                        handleExternalSaleFormChange("amount", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Color"
                      value={externalSaleForm.color}
                      onChange={(e) =>
                        handleExternalSaleFormChange("color", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Size"
                      value={externalSaleForm.size}
                      onChange={(e) =>
                        handleExternalSaleFormChange("size", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<AddIcon />}
                      onClick={handleAddExternalSaleItem}
                      disabled={
                        !externalSaleForm.product ||
                        !externalSaleForm.amount ||
                        !externalSaleForm.quantity ||
                        productCodeValidation.hasStock === true
                      }
                      sx={{
                        bgcolor: lightBlue.main,
                        "&:hover": { bgcolor: lightBlue.dark },
                      }}
                    >
                      Add to List
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {externalSaleItems.length > 0 && (
              <Grid item xs={12}>
                <Paper elevation={2} sx={{ p: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Items ({externalSaleItems.length})
                  </Typography>
                  <List>
                    {externalSaleItems.map((item) => (
                      <ListItem
                        key={item.id}
                        sx={{ bgcolor: "#F8F9FA", borderRadius: 1, mb: 1 }}
                      >
                        <ListItemText
                          primary={item.product}
                          secondary={`Qty: ${item.quantity} | Amount: KSh ${(
                            item.amount * item.quantity
                          ).toFixed(2)}`}
                        />
                        <ListItemSecondaryAction>
                          <IconButton
                            onClick={() =>
                              handleRemoveExternalSaleItem(item.id)
                            }
                            color="error"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                    ))}
                  </List>
                  <Divider sx={{ my: 2 }} />
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="h6">Total:</Typography>
                    <Typography
                      variant="h5"
                      fontWeight="700"
                      color={lightBlue.dark}
                    >
                      KSh{" "}
                      {externalSaleItems
                        .reduce(
                          (sum, item) => sum + item.quantity * item.amount,
                          0,
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseExternalSaleDialog} color="inherit">
            Cancel
          </Button>
          <Button
            onClick={handleFinalizeExternalSale}
            variant="contained"
            disabled={externalSaleItems.length === 0}
            sx={{ bgcolor: "#27AE60", "&:hover": { bgcolor: "#229954" } }}
          >
            Done - Add to Cart ({externalSaleItems.length})
          </Button>
        </DialogActions>
      </Dialog>

      {/* Due Stock Dialog */}
      <Dialog
        open={dueStockDialogOpen}
        onClose={handleCloseDueStockDialog}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF9800",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <WarningIcon sx={{ mr: 1 }} />
            {isWarehouseMode ? "Warehouse" : "Retail"} Due Stock - Items
            Approaching Expiry
          </Box>
          <IconButton
            onClick={handleCloseDueStockDialog}
            sx={{ color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {dueStockItems.length === 0 ? (
            <Alert severity="success" sx={{ mt: 2 }}>
              <Typography variant="h6">
                No items approaching due date within {dueStockThreshold} days
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                All inventory items in this{" "}
                {isWarehouseMode ? "warehouse" : "branch"} are within acceptable
                stock date ranges.
              </Typography>
            </Alert>
          ) : (
            <>
              <Alert severity="warning" sx={{ mb: 2 }}>
                <Typography variant="body1" fontWeight="600">
                  Showing {dueStockItems.length} item(s) with stock due date
                  within {dueStockThreshold} days
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  Consider discounting or prioritizing sales for items with
                  approaching due dates.
                </Typography>
              </Alert>

              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#FFF3E0" }}>
                      <TableCell>
                        <strong>Product Code</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Product Name</strong>
                      </TableCell>
                      {!isWarehouseMode && (
                        <TableCell>
                          <strong>Quantity</strong>
                        </TableCell>
                      )}
                      {isWarehouseMode && (
                        <>
                          <TableCell>
                            <strong>Cartons</strong>
                          </TableCell>
                          <TableCell>
                            <strong>Qty/Carton</strong>
                          </TableCell>
                        </>
                      )}
                      <TableCell>
                        <strong>Stock Due Date</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Days Until Due</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dueStockItems.map((item, index) => {
                      const urgencyColor =
                        item.daysUntilDue <= 7
                          ? "#f44336"
                          : item.daysUntilDue <= 14
                            ? "#ff9800"
                            : "#4caf50";

                      return (
                        <TableRow
                          key={`${item.id}-${index}`}
                          sx={{
                            bgcolor:
                              item.daysUntilDue <= 7 ? "#ffebee" : "inherit",
                            "&:hover": { bgcolor: "#f5f5f5" },
                          }}
                        >
                          <TableCell>{item.productCode || "N/A"}</TableCell>
                          <TableCell>
                            <Typography variant="body2" fontWeight="600">
                              {item.productName || "N/A"}
                            </Typography>
                            {item.aliasProductName && (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {item.aliasProductName}
                              </Typography>
                            )}
                          </TableCell>
                          {!isWarehouseMode && (
                            <TableCell>{item.quantity || 0}</TableCell>
                          )}
                          {isWarehouseMode && (
                            <>
                              <TableCell>{item.cartons || 0}</TableCell>
                              <TableCell>
                                {item.quantityPerCarton || "N/A"}
                              </TableCell>
                            </>
                          )}
                          <TableCell>
                            {item.stockDueDate
                              ? new Date(item.stockDueDate).toLocaleDateString()
                              : "N/A"}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={
                                item.daysUntilDue < 0
                                  ? `${Math.abs(item.daysUntilDue)} day${Math.abs(item.daysUntilDue) !== 1 ? "s" : ""} past due date`
                                  : `${item.daysUntilDue} day${item.daysUntilDue !== 1 ? "s" : ""} to due date`
                              }
                              size="small"
                              sx={{
                                bgcolor: urgencyColor,
                                color: "white",
                                fontWeight: "600",
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<VisibilityIcon />}
                              onClick={() => handleViewDueStockItem(item)}
                            >
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          )}
        </DialogContent>

        <DialogActions
          sx={{ padding: "0px 16px", justifyContent: "space-between" }}
        >
          <TablePagination
            component="div"
            count={dueStockTotalCount}
            page={dueStockPage}
            onPageChange={(event, newPage) => fetchDueStock(newPage)}
            rowsPerPage={DUE_STOCK_PAGE_SIZE}
            rowsPerPageOptions={[DUE_STOCK_PAGE_SIZE]}
            sx={{
              ".MuiTablePagination-toolbar": {
                minHeight: "52px",
              },
            }}
          />
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Button
              variant="contained"
              startIcon={
                isGeneratingDueStockReport ? (
                  <CircularProgress size={16} sx={{ color: "white" }} />
                ) : (
                  <DownloadIcon />
                )
              }
              onClick={handleGenerateDueStockReport}
              disabled={
                isGeneratingDueStockReport || dueStockItems.length === 0
              }
              sx={{
                bgcolor: "#FF9800",
                "&:hover": { bgcolor: "#F57C00" },
                "&.Mui-disabled": { bgcolor: "#FFE0B2", color: "#BF8600" },
              }}
            >
              {isGeneratingDueStockReport ? "Generating..." : "Generate Report"}
            </Button>
            <Button onClick={handleCloseDueStockDialog} color="primary">
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Straight Sale Quick-Add Dialog (no color/size) */}
      <Dialog
        open={straightSaleQuickAddOpen}
        onClose={() => setStraightSaleQuickAddOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: lightBlue.main,
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <AddIcon sx={{ mr: 1 }} />
          Add to Cart
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {selectedStraightSaleProduct && (
            <>
              <Typography variant="h6" gutterBottom>
                {selectedStraightSaleProduct.productName}
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Code: {selectedStraightSaleProduct.productCode}
              </Typography>
              <Typography
                variant="body1"
                fontWeight="600"
                sx={{ color: lightBlue.dark, mb: 2 }}
              >
                KSh{" "}
                {(isWarehouseMode
                  ? (selectedStraightSaleProduct.averageSP ??
                    selectedStraightSaleProduct.sellingPricePerCarton ??
                    0)
                  : (selectedStraightSaleProduct.averageSellingPrice ?? 0)
                ).toFixed(2)}{" "}
                {isWarehouseMode ? "per carton" : "per pair"}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TextField
                fullWidth
                type="number"
                label={isWarehouseMode ? "Cartons" : "Quantity"}
                value={straightSaleQty}
                onChange={(e) => setStraightSaleQty(e.target.value)}
                inputProps={{ min: 1, step: 1 }}
                autoFocus
              />
              {parseFloat(straightSaleQty) > 0 && (
                <Paper
                  elevation={1}
                  sx={{
                    p: 2,
                    mt: 2,
                    bgcolor: lightBlue.lighter,
                    borderRadius: 2,
                  }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body1">Total:</Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: lightBlue.dark }}
                    >
                      KSh{" "}
                      {(
                        parseFloat(straightSaleQty) *
                        (isWarehouseMode
                          ? (selectedStraightSaleProduct.averageSP ??
                            selectedStraightSaleProduct.sellingPricePerCarton ??
                            0)
                          : (selectedStraightSaleProduct.averageSellingPrice ??
                            0))
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                </Paper>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setStraightSaleQuickAddOpen(false)}
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddStraightSaleToCart}
            disabled={!straightSaleQty || parseFloat(straightSaleQty) <= 0}
            sx={{
              bgcolor: lightBlue.main,
              "&:hover": { bgcolor: lightBlue.dark },
            }}
          >
            Add to Cart
          </Button>
        </DialogActions>
      </Dialog>

      {/* Service Quick-Add Dialog */}
      <Dialog
        open={serviceQuickAddOpen}
        onClose={() => setServiceQuickAddOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: lightBlue.main,
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          <StyleIcon sx={{ mr: 1 }} />
          Add Service to Cart
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {selectedServiceProduct && (
            <>
              <Typography variant="h6" gutterBottom>
                {selectedServiceProduct.productName}
              </Typography>
              {selectedServiceProduct.productCategory && (
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Category: {selectedServiceProduct.productCategory}
                </Typography>
              )}
              <Typography
                variant="body1"
                fontWeight="600"
                sx={{ color: lightBlue.dark, mb: 2 }}
              >
                KSh{" "}
                {(
                  selectedServiceProduct.unitPrice ||
                  selectedServiceProduct.retailPrice ||
                  0
                ).toFixed(2)}{" "}
                / {selectedServiceProduct.unitofMeasure || "unit"}
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <TextField
                fullWidth
                type="number"
                label="Quantity"
                value={serviceQty}
                onChange={(e) => setServiceQty(e.target.value)}
                inputProps={{ min: 1, step: 1 }}
                autoFocus
              />
              {parseFloat(serviceQty) > 0 && (
                <Paper
                  elevation={1}
                  sx={{
                    p: 2,
                    mt: 2,
                    bgcolor: lightBlue.lighter,
                    borderRadius: 2,
                  }}
                >
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="body1">Total:</Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ color: lightBlue.dark }}
                    >
                      KSh{" "}
                      {(
                        parseFloat(serviceQty) *
                        (selectedServiceProduct.unitPrice ||
                          selectedServiceProduct.retailPrice ||
                          0)
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                </Paper>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setServiceQuickAddOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddServiceToCart}
            disabled={!serviceQty || parseFloat(serviceQty) <= 0}
            sx={{
              bgcolor: lightBlue.main,
              "&:hover": { bgcolor: lightBlue.dark },
            }}
          >
            Add to Cart
          </Button>
        </DialogActions>
      </Dialog>

      {/* Payment Dialog */}
      <Payment
        cart={cart}
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        onConfirmPayment={handleConfirmPayment}
        branchName={selectedBranchName}
        isWarehouse={isWarehouseMode}
        requireMpesaCodeForCash={requireMpesaCodeForCash}
        onClearCart={() => {
          setCart([]); // Clear the cart
          setExternalSaleItems([]); // Also clear external sale items if needed
        }}
      />

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </Box>
  );
};

export default ShoeInventoryPOS;
